webpackJsonp([1],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e(__webpack_require__(9), __webpack_require__(6)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["bosket-riot"] = e(require("@bosket/core"), require("riot")) : t["bosket-riot"] = e(t["bosket-core"], t.riot);
}("undefined" != typeof self ? self : this, function (t, e) {
  return function (t) {
    function e(o) {
      if (n[o]) return n[o].exports;var i = n[o] = { i: o, l: !1, exports: {} };return t[o].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }var n = {};return e.m = t, e.c = n, e.d = function (t, n, o) {
      e.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: o });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 50);
  }({ 0: function _(e, n) {
      e.exports = t;
    }, 10: function _(t, n) {
      t.exports = e;
    }, 50: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });var o = n(6);Object.keys(o).forEach(function (t) {
        "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, { enumerable: !0, get: function get() {
            return o[t];
          } });
      }), n(54);
    }, 51: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });e.optsMixin = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "opts";return { init: function init() {
            this.on("update", this.updateOpts), this._originalOpts = Object.keys(this.opts), this.updateOpts();
          }, updateOpts: function updateOpts() {
            if (this.opts) for (var e in this.opts[t]) {
              ~this._originalOpts.indexOf(e) || (this.opts[e] = this.opts[t][e]);
            }
          } };
      };
    }, 52: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });e.transitionMixin = function (t) {
        return { init: function init() {
            var e = this;if (this.opts.transition) {
              var n = this.opts.transition.name,
                  o = this.unmount,
                  i = function i() {
                var o = (t || function () {
                  return e.root;
                })();o && (o.classList.add(n), o.classList.add(n + "-mount"), setTimeout(function () {
                  o.classList.remove(n + "-mount");
                }, 10));
              },
                  r = !1,
                  s = function s() {
                if (!r) {
                  r = !0;var i = (t || function () {
                    return e.root;
                  })();if (!i) return o.call(e);i.addEventListener("transitionend", function () {
                    o.call(e);
                  }), i.classList.add(n + "-unmount");
                }
              };this.one("mount", i), Object.defineProperty(this, "unmount", { value: s });
            }
          } };
      };
    }, 53: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });e.listenerMixin = function (t) {
        var e = t.eventType,
            n = void 0 === e ? "click" : e,
            o = t.callback,
            i = t.regulate,
            r = void 0 !== i && i;return { init: function init() {
            var t = !1,
                e = function e(_e) {
              o && (r ? (t || window.requestAnimationFrame(function () {
                return o(_e, function () {
                  return t = !1;
                });
              }), t = !0) : o(_e));
            };this.one("mount", function () {
              document.addEventListener(n, e);
            }), this.one("unmount", function () {
              document.removeEventListener(n, e);
            });
          } };
      };
    }, 54: function _(t, e, n) {
      "use strict";
      n(55), n(56), n(57);
    }, 55: function _(t, e, n) {
      n(10).tag2("treeview", '<div class="{rootNode.mixCss(⁗TreeView⁗)}"> <input type="search" class="{rootNode.mixCss(⁗search⁗)}" if="{inputs.get().search}" placeholder="{inputs.get().labels[⁗search.placeholder⁗]}" oninput="{onSearch}"> <treeviewnode opts="{inputs.get()}" selection="{opts.selection}" model="{inputs.get().sort ? inputs.get().model.sort(inputs.get().sort) : inputs.get().model}" filteredmodel="{filtered}" onselection="{rootNode.onSelect}" dragndrop="{rootNode.wrapDragNDrop()}" ancestors="{[]}" searched="{search.trim()}" depth="{0}"> </TreeViewNode> </div>', "", "", function (t) {
        "use strict";
        var e = Object.assign || function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];for (var o in n) {
              Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
            }
          }return t;
        },
            o = this,
            i = n(0),
            r = n(6);this.mixin((0, r.optsMixin)()), this.mixin((0, r.listenerMixin)({ eventType: "keyup", callback: function callback(t) {
            return o.rootNode.onKey(t);
          } })), this.mixin((0, r.listenerMixin)({ eventType: "keydown", callback: function callback(t) {
            return o.rootNode.onKey(t);
          } })), this.filtered = null, this.search = "", this.onSearch = function (t) {
          var e = t.currentTarget.value;o.search = e, o.filtered = o.rootNode.filterTree(e);
        }, this.inputs = { get: function get() {
            return e({}, i.defaults, o.opts, { onSelect: o.opts.onselection });
          } }, this.outputs = { onSelect: this.inputs.get().onselection, onDrag: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drag, onOver: this.inputs.get().dragndrop && this.inputs.get().dragndrop.over, onEnter: this.inputs.get().dragndrop && this.inputs.get().dragndrop.enter, onLeave: this.inputs.get().dragndrop && this.inputs.get().dragndrop.leave, onDrop: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drop, onCancel: this.inputs.get().dragndrop && this.inputs.get().dragndrop.cancel }, this.state = { get: function get() {
            return e({}, o);
          }, set: function set(t) {
            for (var e in t) {
              e in o && (o[e] = t[e]);
            }
          } }, this.rootNode = new i.RootNode(this.inputs, this.outputs, this.state, this.update);
      });
    }, 56: function _(t, e, n) {
      n(10).tag2("treeviewnode", '<ul if="{!opts.folded && !opts.loading}" data-is="with-transition" transition="{opts.transition}" class="{node.ulCss()}" ondragover="{!opts.depth ? rootEvents.onDragOver : null}" ondragenter="{!opts.depth ? rootEvents.onDragEnter : null}" ondragleave="{!opts.depth ? rootEvents.onDragLeave : null}" ondrop="{!opts.depth ? rootEvents.onDrop : null}"> <li each="{item in getModel()}" class="{node.liCss(item)}" draggable="{node.getDragEvents(item).draggable}" ondragstart="{node.getDragEvents(item).onDragStart}" ondragover="{node.getDragEvents(item).onDragOver}" ondragenter="{node.getDragEvents(item).onDragEnter}" ondragleave="{node.getDragEvents(item).onDragLeave}" ondragend="{node.getDragEvents(item).onDragEnd}" ondrop="{node.getDragEvents(item).onDrop}"> <span class="{parent.node.mixCss(⁗item⁗)}" onclick="{parent.node.onClick(item)}"> <span if="{renderOpener(item, ⁗left⁗)}" class="{node.mixCss(⁗opener⁗)}" onclick="{node.onOpener(item, parent.opts.openerOpts.callback)}"></span> <virtual if="{!parent.opts.displaytag}"> {parent.opts.display(item, parent.opts)} </virtual> <virtual if="{parent.opts.displaytag}" data-is="{parent.opts.displaytag(item, parent.opts)}" item="{item}" inputs="{inputs.get()}"></virtual> <span if="{renderOpener(item, ⁗right⁗)}" class="{node.mixCss(⁗opener⁗)}" onclick="{node.onOpener(item, parent.opts.openerOpts.callback)}"></span> </span> <treeviewnode if="{node.hasChildren(item) || node.isAsync(item)}" opts="{parent.opts}" selection="{parent.opts.selection}" model="{getChildModel(item)}" filteredmodel="{getChildFiltered(item)}" ancestors="{getAncestors(item)}" depth="{parent.opts.depth + 1}" folded="{node.isFolded(item)}" loading="{node.isAsync(item) && !node.isFolded(item)}"> </TreeViewNode> </li> </ul> <span if="{opts.loading}"></span>', "", "", function (t) {
        "use strict";
        var e = this,
            o = n(0),
            i = n(6);this.mixin((0, i.optsMixin)()), this.unfolded = [], this.getModel = function () {
          return e.opts.searched ? e.opts.model.filter(function (t) {
            return e.opts.filteredmodel.has(t);
          }) : e.opts.model;
        }, this.getChildModel = function (t) {
          var n = t[e.opts.category];return e.node.isAsync(t) && !e.node.isFolded(t) && e.node.pending.indexOf(t) < 0 && e.node.unwrapPromise(t), e.node.isAsync(t) || (n = e.opts.sort ? n.sort(e.opts.sort) : n), n;
        }, this.getChildFiltered = function (t) {
          return e.opts.searched ? e.opts.filteredmodel.get(t) : null;
        }, this.getAncestors = function (t) {
          return [].concat(e.opts.ancestors, [t]);
        }, this.renderOpener = function (t, n) {
          return (e.node.hasChildren(t) || e.node.isAsync(t)) && e.opts.openerOpts.position === n;
        };var r = function r() {
          e.opts.onSelect = e.opts.onselection, e.opts.disabled = e.opts.disable;
        };this.on("update", r), r(), this.inputs = { get: function get() {
            return e.opts;
          } }, this.state = { get: function get() {
            return e;
          }, set: function set(t) {
            for (var n in t) {
              n in e && (e[n] = t[n]);
            }
          } }, this.node = new o.TreeNode(this.inputs, null, this.state, this.update), this.rootEvents = this.node.getDragEvents();
      });
    }, 57: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });var o = n(10),
          i = function (t) {
        return t && t.__esModule ? t : { default: t };
      }(o),
          r = n(6);e.default = i.default.tag("with-transition", !1, function (t) {
        var e = this;this.mixin((0, r.transitionMixin)());var n = function n() {
          for (var t in e.parent) {
            e.parent.hasOwnProperty(t) && (e[t] = e.parent[t]);
          }
        };n(), this.on("update", n);
      });
    }, 6: function _(t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });var o = n(51);Object.keys(o).forEach(function (t) {
        "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, { enumerable: !0, get: function get() {
            return o[t];
          } });
      });var i = n(52);Object.keys(i).forEach(function (t) {
        "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, { enumerable: !0, get: function get() {
            return i[t];
          } });
      });var r = n(53);Object.keys(r).forEach(function (t) {
        "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, { enumerable: !0, get: function get() {
            return r[t];
          } });
      });
    } });
});
//# sourceMappingURL=riot.umd.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)(module)))

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(492);

var _introduction = __webpack_require__(493);

var _introduction2 = _interopRequireDefault(_introduction);

var _usage = __webpack_require__(496);

var _usage2 = _interopRequireDefault(_usage);

var _treeview = __webpack_require__(507);

var _treeview2 = _interopRequireDefault(_treeview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_introduction2.default, _usage2.default, _treeview2.default];

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(6);

var _riot2 = _interopRequireDefault(_riot);

__webpack_require__(66);

__webpack_require__(203);

__webpack_require__(490);

__webpack_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.onload = function () {
    _riot2.default.mount("*");
};

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(491);

__webpack_require__(524);

__webpack_require__(525);

__webpack_require__(526);

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('app', '    <div class="App">\n            <planner plan="{plan}" maxdepth="{1}" sticky="{true}"></planner>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

__webpack_require__(67);

var _plan = __webpack_require__(204);

var _plan2 = _interopRequireDefault(_plan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.plan = _plan2.default;
});

    
  

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('planner', '    <div class="Planner">\n        <div class="Planner opener" ref="opener">\n            <i class="{⁗fa⁗: true,                 ⁗fa-bars⁗: !opened,                 ⁗fa-times⁗: opened}"></i>\n        </div>\n        <aside ref="sidePanel" class="{⁗Planner⁗: true, ⁗side-panel⁗: true, opened: opened}">\n            <div><h1>Table of contents</h1></div>\n            <treeview model="{opts.plan}" css="{{ TreeView: ⁗PlannerTree⁗ }}" category="subs" selection="{selection}" onselection="{updateSelection}" strategies="{{ selection: [⁗ancestors⁗], click: [⁗select⁗], fold: [ foldDepth(), ⁗not-selected⁗, ⁗no-child-selection⁗ ]}}" openeropts="{{ position: ⁗none⁗ }}" displaytag="{display}">\n            </TreeView>\n        </aside>\n        <div ref="content" class="Planner content">\n            <div each="{p in opts.plan}">\n                <planner-content plan="{p}"></planner-content>\n            </div>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

var _riot = __webpack_require__(203);

__webpack_require__(68);

this.mixin((0, _riot.listenerMixin)({ callback: function callback(e) {
        return _this.onDocumentClick(e);
    } }));
this.mixin((0, _riot.listenerMixin)({ eventType: "scroll", callback: function callback() {
        return _this.onDocumentScroll.apply(_this, arguments);
    }, regulate: true }));
this.mixin((0, _riot.listenerMixin)({ eventType: "scroll", callback: function callback() {
        return _this.onStickyScroll.apply(_this, arguments);
    }, regulate: true }));

this.selection = [];
this.opened = false;
this.updateSelection = function (_) {
    _this.selection = _;
    _this.update();
};
this.display = function (item) {
    return "display-planner-content";
};
this.foldDepth = function () {
    var max = _this.opts.maxdepth;
    return function () {
        return this.inputs.get().depth >= max;
    };
};
this.findPosition = function () {
    var position = [];
    var loop = function loop(arr) {
        var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        for (var i = 0; i < arr.length; i++) {
            var elt = arr[i];
            var domElt = document.getElementById(acc.length > 0 ? acc.join("#") + "#" + elt.title : elt.title);
            if (domElt && domElt.parentElement && domElt.parentElement.getBoundingClientRect().top <= 50 && domElt.parentElement.getBoundingClientRect().bottom > 10) {
                position.push(elt);
                if (elt.subs) loop(elt.subs, [].concat(acc, [elt.title]));
                break;
            }
        }
    };
    loop(_this.opts.plan);
    return position;
};
this.one("mount", function () {
    _this.selection = _this.findPosition();
    _this.update();
});

this.onDocumentClick = function (ev) {
    if (!(ev.target instanceof HTMLElement)) return;
    if (_this.refs.opener && _this.refs.opener.contains(ev.target)) {
        _this.opened = !_this.opened;
    } else if (_this.opened && _this.refs.sidePanel && !_this.refs.sidePanel.contains(ev.target)) {
        _this.opened = false;
    }
    _this.update();
};

this.onDocumentScroll = function (ev, end) {
    var position = _this.findPosition();
    var newHash = "#" + position.map(function (_) {
        return _.title;
    }).join("#");
    if (newHash !== (window.location.hash || "#")) {
        _this.selection = position;
        _this.update();
        window.history && window.history.replaceState({}, document.title, "#" + position.map(function (_) {
            return _.title;
        }).join("#"));
    }

    // Prevents safari security exception (SecurityError (DOM Exception 18): Attempt to use history.replaceState() more than 100 times per 30.000000 seconds)
    setTimeout(function () {
        return end();
    }, 100);
};

this.onStickyScroll = function (ev, end) {
    if (!_this.opts.sticky) return;
    if (_this.refs.content.getBoundingClientRect().top > 0) {
        _this.refs.sidePanel.style.position = "absolute";
        _this.refs.sidePanel.style.top = "";
        end();
    } else {
        _this.refs.sidePanel.style.position = "fixed";
        _this.refs.sidePanel.style.top = "0px";
        end();
    }
};
});

riot.tag2('planner-content', '    <div class="{depth === 1 ? ⁗chapter⁗ : ⁗planner-section⁗}">\n        <h1 if="{depth === 1}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h1>\n        <h2 if="{depth === 2}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h2>\n        <h3 if="{depth === 3}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h3>\n        <h4 if="{depth === 4}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h4>\n        <h5 if="{depth === 5}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h5>\n        <h6 if="{depth === 6}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </h6>\n        <p if="{depth > 6}" id="{id()}" class="Planner heading">\n            <span>{plan.title}</span>\n            <span class="icons">\n                <a href="{⁗#⁗ + id()}"><i class="fa fa-link"></i></a>\n                <a if="{plan.editLink}" href="{plan.editLink}" target="_blank" rel=" noopener noreferrer">\n                    <i class="fa fa-pencil"></i>\n                </a>\n            </span>\n        </p>\n        <div data-is="{plan.content}"></div>\n        <div if="{plan.subs}">\n            <div each="{s in plan.subs}">\n                <planner-content plan="{s}" prefix="{prefix ? prefix+\'#\'+plan.title : plan.title}" depth="{depth + 1}"></planner-content>\n            </div>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.plan = this.opts.plan;
this.depth = this.opts.depth || 1;
this.prefix = this.opts.prefix || "";
this.id = function () {
        return _this.prefix ? _this.prefix + "#" + _this.plan.title : _this.plan.title;
};
});

riot.tag2('display-planner-content', '    <a href="{href()}">{opts.item.title}</a>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.href = function () {
    return _this.opts.inputs.ancestors.map(function (a) {
        return "#" + a.title;
    }).join("") + "#" + _this.opts.item.title;
};
});

    
  

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(494);

__webpack_require__(495);

exports.default = {
    title: "Introduction",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/introduction/index.js",
    content: "introduction"
};

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('introduction', '    <p>\n        This page covers the <em class="highlight"><a href="http://riotjs.com/" target="_blank" rel="noopener noreferrer">Riot.js</a></em> implementation of the <em><a href="..">Bosket library</a></em>.<br>\n        Versatile and flexible, Bosket eases the creation and design of tree view components.<br><br>\n        As a matter of fact <em><a href="https://github.com/elbywan/bosket/tree/master/docs/riot/plan" target="_blank" rel="noopener noreferrer">this whole documentation</a></em> is built around Bosket using <em><a href="https://github.com/elbywan/bosket/blob/master/docs/riot/plan/Planner.tag" target="_blank" rel="noopener noreferrer">a custom component</a></em> which automatically creates the table of contents and the anchors.<br>\n        <br>\n        Multiple use case examples (including the source code and the css stylesheet) are provided alongside the documentation.\n    </p>\n    <h4 class="center-text">API views implemented with Bosket</h4>\n    <introductiondemos></introductiondemos>\n', '', '', function(opts) {
});

    
  

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('introductiondemos', '    <div class="IntroductionDemos">\n       <div class="center-text">\n           <span class="button-row">\n               <button each="{d in demos}" onclick="{setDemo(d)}" class="{selected: d === demo}">\n                   {d}\n               </button>\n           </span>\n       </div>\n       <componentdemo files="{getFiles(demo)}">\n            <virtual data-is="{parent.demo.toLowerCase()}"></virtual>\n       </ComponentDemo>\n   </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

__webpack_require__(70);

this.demos = ["HackerNews", "Pokeapi", "ChuckNorris"];
this.demo = this.demos[0];
this.setDemo = function (d) {
    return function (_) {
        return _this.demo = d;
    };
};
this.getFiles = function (demo) {
    return ["./components/Demos/" + demo + "/" + demo + ".tag", "../common/styles/" + demo + ".css", "./components/Demos/" + demo + "/models.js"];
};
});

    
  

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(497);

var _import2 = __webpack_require__(498);

var _import3 = _interopRequireDefault(_import2);

var _dataModel = __webpack_require__(500);

var _dataModel2 = _interopRequireDefault(_dataModel);

var _style = __webpack_require__(503);

var _style2 = _interopRequireDefault(_style);

var _onlineSnippets = __webpack_require__(505);

var _onlineSnippets2 = _interopRequireDefault(_onlineSnippets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    title: "Usage",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/usage/index.js",
    content: "usage",
    subs: [_import3.default, _onlineSnippets2.default, _dataModel2.default, _style2.default]
};

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('usage', '    <div>\n        <p>It is assumed that you followed the installation <em><a href="../#Setup">guidelines</a></em>.</p>\n    </div>\n', '', '', function(opts) {
});

    
  

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(499);

exports.default = {
    title: "Import",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/react/riot/usage/import/index.js",
    content: "import"
};

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('import', '    <p>Bosket/riot is bundled in <em><a href="http://bob.yexley.net/umd-javascript-that-runs-anywhere/" target="_blank" ref="noopener noreferrer">UMD</a></em> format.</p>\n\n    <syntax-highlight offset="{8}">\n        /* How to register Bosket tags : */\n\n        // ESM imports\n        import "@bosket/riot"\n\n        // Commonjs\n        require("@bosket/riot")\n    </syntax-highlight>\n\n    <p>Or just include a link to the <em>@bosket/riot/bundle/riot.umd.min.js</em> file inside a script tag.</p>\n\n    <syntax-highlight language="html" content="{htmlCode}"></syntax-highlight>\n', '', '', function(opts) {
"use strict";

/* eslint-disable */
this.htmlCode = "\n            <script src=\".../path/to/riot.js\"></script>\n            <script src=\".../path/to/riot.umd.min.js\"></script>";
/* eslint-enable */
});

    
  

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(501);

__webpack_require__(502);

exports.default = {
    title: "Data model",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/usage/data%20model/index.js",
    content: "datamodel"
};

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('datamodel', '    <span>\n        <p>To populate the component you need to provide a suitable data model.</p>\n        <syntax-highlight offset="{12}">\n            // A model is simply an array of objects.\n\n            const model = [\\{\n                a: 1,\n                b: 2,\n                /* ... */\n                // If the object has \'children\', it must contain a property value\n                // being an array of objects that respects the same contract.\n                // \'children\' is just a placeholer name, you can use and specify any\n                // label as a prop of the component.\n                children: [\\{\n                    /* ... */,\n                    // If you would like the children to be loaded asynchronously when\n                    // the node is unfolded, you may use a function returning a Promise.\n                    children: () => \\{\n                        return new Promise(resolve =>\n                            setTimeout(() =>\n                                // resolves into the children model\n                                resolve([\\{ a: 1, b: 2 \\}]), 1000))\n                    \\}\n                \\}],\n            \\},\n            /* ... */\n            ]\n        </syntax-highlight>\n\n        <p>The logic is pretty simple as you can see below, a model and its tree representation as a Bosket view :</p>\n\n        <syntax-highlight offset="{12}">\n            [\n                \\{ label: "Click me, I\'m a node with two children.", children: [\n                    \\{ label: "I am a childless leaf." \\},\n                    \\{ label: "I am a also a childless leaf." \\}\n                ]\\},\n                \\{ label: "I\'m a leaf, I do not have children." \\},\n                \\{ label: "I am an asynchronous node, click me and wait one second.", children: () =>\n                    new Promise(resolve =>\n                        setTimeout(() =>\n                            resolve([\\{ label: "It took exactly one second to fetch me the first time, I am cached afterwards." \\}]), 1000))\n                \\}\n            ]\n        </syntax-highlight>\n\n        <div style="border: 2px solid black; cursor: pointer;">\n           <data-model-tree></data-model-tree>\n        </div>\n    </span>\n', '', '', function(opts) {
});

    
  

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('data-model-tree', '    <treeview model="{sampleModel}" category="children" selection="{selection}" onselection="{updateSelection}" display="{display}">\n    </TreeView>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.sampleModel = [{ label: "Click me, I'm a node with two children.", children: [{ label: "I am a childless leaf." }, { label: "I am a also a childless leaf." }] }, { label: "I'm a leaf, I do not have children." }, { label: "I am an asynchronous node, click me and wait one second.", children: function children() {
        return new Promise(function (resolve) {
            return setTimeout(function () {
                return resolve([{ label: "It took exactly one second to fetch me the first time, I am cached afterwards." }]);
            }, 1000);
        });
    }
}];

this.updateSelection = function (_) {
    _this.selection = _;_this.update();
};
this.selection = [];
this.display = function (_) {
    return _.label;
};
});

    
  

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(504);

exports.default = {
    title: "Style",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/usage/style/index.js",
    content: "usage-style"
};

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('usage-style', '    <div>\n        <p>\n            <em>Once the component is included and rendered in your code, you will need to style it using css, otherwise it will look like a good old fashioned html unordered list.</em><br>\n            <br>\n            Have a look at <em><a href="#TreeView#Css#Empty stylesheet">the empty stylesheet</a></em> with classes and elements already filled.<br>\n            Also, feel free to peek at the included <em><a href="#TreeView#Demo">demos css source code</a></em>.\n        </p>\n\n        <syntax-highlight language="html">{parent.htmlCode}</syntax-highlight>\n\n        <p>\n            The css class names can be overrided by changing the <em><a href="#TreeView#Optional properties#css">css property</a></em>.\n            <br>\n            You should also check the full <em><a href="#TreeView#Css#Layout">html layout</a></em>.\n        </p>\n    </div>\n', '', '', function(opts) {
"use strict";

this.htmlCode = "\n            <head>\n                <link rel=\"stylesheet\" type=\"text/css\" href=\"[your bosket stylesheet].css\">\n            </head>\n        ";
});

    
  

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(506);

exports.default = {
    title: "Online snippets",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/react/riot/usage/online-snippets/index.js",
    content: "online-snippets"
};

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('online-snippets', '    <iframe if="{!hidden}" width="100%" height="300" title="jsfiddle-react" src="//jsfiddle.net/elbywan/w17o67vw/embedded/js,html,result/dark/" allowfullscreen="allowfullscreen" frameborder="0"></iframe>\n    <div if="{hidden}" class="iframe-hide" onclick="{unHide}"><span>Click to load snippet</span></div>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.hidden = true;
this.unHide = function () {
        _this.hidden = false;
};
});

    
  

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basicUsage = __webpack_require__(508);

var _basicUsage2 = _interopRequireDefault(_basicUsage);

var _demo = __webpack_require__(510);

var _demo2 = _interopRequireDefault(_demo);

var _css = __webpack_require__(512);

var _css2 = _interopRequireDefault(_css);

var _requiredProperties = __webpack_require__(520);

var _requiredProperties2 = _interopRequireDefault(_requiredProperties);

var _optionalProperties = __webpack_require__(522);

var _optionalProperties2 = _interopRequireDefault(_optionalProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    title: "TreeView",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/index.js",
    subs: [_basicUsage2.default, _demo2.default, _requiredProperties2.default, _optionalProperties2.default, _css2.default]
};

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(509);

exports.default = {
    title: "Basic Usage",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/basic%20usage/index.js",
    content: "basic-usage"
};

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('basic-usage', '    <div>\n        <p>\n            Just drop the TreeView tag in your templates after <em><a href="#Usage#Import">registering it</a></em>.<br>\n            <br>\n            Appearance can be tweaked using <em><a href="#TreeView#Css">css</a></em>.\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n        <TreeView\n\n            // Required //\n\n            model=         /* [the data model](#TreeView#Required properties#model) */\n            category=      /* [name of the property containing the children](#TreeView#Required properties#category) */\n            selection=     /* [the selection array, updated when the user (de)selects items](#TreeView#Required properties#selection) */\n            onselection=   /* [selection callback](#TreeView#Required properties#onselection) */\n\n            // Optional //\n\n            display=       /* [customize output for each element in the tree](#TreeView#Optional properties#display) */\n            displaytag=    /* [wrap output inside a tag of your choice](#TreeView#Optional properties#displaytag) */\n            strategies=    /* [behaviour on selection, click or fold](#TreeView#Optional properties#strategies) */\n            sort=          /* [sort items](#TreeView#Optional properties#sort) */\n            disable=       /* [disable certain items](#TreeView#Optional properties#disabled) */\n            search=        /* [enables the search bar](#TreeView#Optional properties#search) */\n            async=         /* [how to perform asynchronous loading](#TreeView#Optional properties#async) */\n            dragndrop=     /* [drag'n'drop configuration](#TreeView#Optional properties#dragndrop) */\n            openeropts=    /* [opener 'arrow' options](#TreeView#Optional properties#openeropts) */\n            labels=        /* [override default labels](#TreeView#Optional properties#labels) */\n            css=           /* [override default css classes](#TreeView#Optional properties#css) */\n            transition=    /* [transitions on mount / unmount](#TreeView#Optional properties#transition) */\n        />\n        ";
});

    
  

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(511);

exports.default = {
    title: "Demo",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/demo/index.js",
    content: "treeview-demo-section"
};

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeview-demo-section', '    <div>\n        <h4>\n            <a download="BosketTreeView.css" href="./components/Demos/TreeView/TreeViewDemo.css" class="anchor-button basic-button">\n                <i class="fa fa-download"></i>Download stylesheet\n            </a>\n        </h4>\n        <treeviewsection></treeviewsection>\n    </div>\n', '', '', function(opts) {
});

    
  

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(513);

var _layout = __webpack_require__(514);

var _layout2 = _interopRequireDefault(_layout);

var _emptyStylesheet = __webpack_require__(517);

var _emptyStylesheet2 = _interopRequireDefault(_emptyStylesheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    title: "Css",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/css/index.js",
    content: "treeview-css",
    subs: [_layout2.default, _emptyStylesheet2.default]
};

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeview-css', '    <div>\n        <p>\n            A TreeView is basically made of multiple nested unordered lists.\n            The component applies css classes to the lists and their items throughout its lifecycle.\n        </p>\n    </div>\n', '', '', function(opts) {
});

    
  

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(515);

exports.default = {
    title: "Layout",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/css/layout/index.js",
    content: "treeview-layout"
};

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeview-layout', '    <div>\n        <p>\n            Below is the <em>full HTML layout</em> of a TreeView, with the <em><a href="#TreeView#Optional properties#css">default classes</a></em>.<br>\n        </p>\n        <syntax-highlight language="html">{parent.htmlLayout}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

var _html_layout = __webpack_require__(516);

var _html_layout2 = _interopRequireDefault(_html_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.htmlLayout = _html_layout2.default;
});

    
  

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "\n<!-- Presets override this class with the preset component name. -->\n<div class=\"TreeView\">\n\n    <!-- If [search](#TreeView#Optional properties#search) is defined, hidden otherwise.-->\n    <input type=\"search\" class=\"search\" />\n\n    <!-- 'depth-0'' is the root list, each nested list has the depth incremented by 1 -->\n    <!-- If [transition](#TreeView#Optional properties#transition) is set, the transition css classes will be set on this element. -->\n    <ul class=\"depth-0\">\n        <li>\n            <span class=\"item\">\n                <!-- Return of the [display](#TreeView#Optional properties#display) or [displaytag](#TreeView#Optional properties#displaytag) function.-->\n            </span>\n        </li>\n\n        <!-- If the item is selected. -->\n        <li class=\"selected\">\n            <span class=\"item\"></span>\n        </li>\n\n        <!-- A category is a node having children. This node is folded, its children are hidden. -->\n        <li class=\"folded category\">\n            <span class=\"item\">\n                <!-- If [openeropts](#TreeView#Optional properties#openeropts) position is set, hidden otherwise. -->\n                <span class=\"opener\"></span>\n            </span>\n        </li>\n\n        <!-- This category is not folded. -->\n        <li class=\"category\">\n            <span class=\"item\"><span class=\"opener\"></span></span>\n\n            <!-- Children. -->\n            <ul class=\"depth-1\">\n\n                <!-- Asynchronous, folded node. See [async](#TreeView#Optional properties#async). -->\n                <li class=\"category folded async\">\n                    <span class=\"item\"><span class=\"opener\"></span></span>\n                </li>\n\n                <!-- This async is currently fetching its children, waiting for the Promise to resolve. See [async](#TreeView#Optional properties#async). -->\n                <li class=\"category loading\">\n                    <span class=\"item\"><span class=\"opener\"></span></span>\n                </li>\n\n                <!-- Disabled item, cannot be selected. See [disabled](#TreeView#Optional properties#disabled). -->\n                <li class=\"disabled\">\n                    <span class=\"item\"><span class=\"opener\"></span></span>\n                </li>\n\n                <!-- An item is being dragged over. See [dragndrop](#TreeView#Optional properties#dragndrop). -->\n                <li class=\"dragover\">\n                    <span class=\"item\"><span class=\"opener\"></span></span>\n                </li>\n\n                <!-- An invalid drop target. See [dragndrop](#TreeView#Optional properties#dragndrop). -->\n                <li class=\"nodrop\">\n                    <span class=\"item\"><span class=\"opener\"></span></span>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</div>";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(518);

exports.default = {
    title: "Empty stylesheet",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/css/empty-stylesheet/index.js",
    content: "treeview-empty-stylesheet"
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeview-empty-stylesheet', '    <div>\n        <h4>\n            <a ref="anchor" download="bosket_empty_stylesheet.css" class="anchor-button basic-button">\n                <i class="fa fa-download"></i>\n                Download stylesheet\n            </a>\n        </h4>\n\n        <syntax-highlight language="css">{parent.emptyStylesheet}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

var _empty_stylesheet = __webpack_require__(519);

var _empty_stylesheet2 = _interopRequireDefault(_empty_stylesheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.emptyStylesheet = _empty_stylesheet2.default;
this.one("mount", function () {
    _this.refs.anchor.href = window.URL.createObjectURL(new Blob([_empty_stylesheet2.default], { type: "text/css" }));
});
});

    
  

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "\n/* Elements */\n.TreeView ul {}\n.TreeView ul > li {}\n.TreeView ul > li > span.item {}\n.TreeView > input[type=\"search\"] {}\n\n/* Root list */\n.TreeView ul.depth-0 {}\n\n/* Not disabled */\n.TreeView ul li:not(.disabled) {}\n.TreeView ul li:not(.disabled) > span.item {}\n\n/* Selected */\n.TreeView ul li.selected {}\n.TreeView ul li.selected > span.item {}\n\n/* Categories : Nodes with children */\n.TreeView ul li.category {}\n.TreeView ul li.category > span.item {}\n/* Folded */\n.TreeView ul li.category.folded {}\n.TreeView ul li.category.folded > span.item {}\n/* Unfolded */\n.TreeView ul li.category:not(.folded) {}\n.TreeView ul li.category:not(.folded) > span.item {}\n/* Opener */\n.TreeView ul li.category > span.item > .opener {}\n.TreeView ul li.category > span.item > .opener::after {}\n/* Folded async */\n.TreeView li.category.async {}\n.TreeView li.category.async > span.item {}\n/* Loading async */\n.TreeView li.category.loading {}\n.TreeView li.category.loading > span.item {}\n\n/* Animations on tag mount / unmount */\n.TreeViewTransition {}\n.TreeViewTransition-mount {}\n.TreeViewTransition-unmount {}\n\n/* Drag'n'drop */\n.TreeView ul.dragover {}\n.TreeView li.dragover {}\n.TreeView li.dragover > span.item {}\n.TreeView li.nodrop {}\n.TreeView li.nodrop > span.item {}";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(521);

exports.default = {
    title: "Required properties",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/required-properties/index.js",
    subs: [{
        title: "model",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/required-properties/index.js",
        content: "model-prop"
    }, {
        title: "category",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/required-properties/index.js",
        content: "category-prop"
    }, {
        title: "selection",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/required-properties/index.js",
        content: "selection-prop"
    }, {
        title: "onselection",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/required-properties/index.js",
        content: "onselection-prop"
    }]
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('model-prop', '    <div class="marged">\n        <pre class="itemType">Object[]</pre>\n        <p>\n            An array of objects which is used to populate the component.<br>\n            The format is detailed in the <em><a href="#Usage#Data model">data model</a></em> section.\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ model={ model } />\n            <script>\n                this.model = [\n                    { label: \"One\" },\n                    { label: \"Two\" },\n                    { label: \"Three\", list: [\n                        { label: \"Four\" },\n                        { label: \"Five\" }\n                    ] }\n                ]\n            </script>"; // eslint-disable-line no-useless-escape
});

riot.tag2('category-prop', '    <div class="marged">\n        <pre class="itemType">string</pre>\n        <p>\n            The name of the property containing the children.<br>\n            In the example above, it would be "list".\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "<TreeView /* ... */ category=\"list\" />";
});

riot.tag2('selection-prop', '    <div class="marged">\n        <pre class="itemType">Object[]</pre>\n        <p>\n            An array which references the selected objects.\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ selection={ selection } />\n            <script>\n                this.selection = []\n            </script>";
});

riot.tag2('onselection-prop', '    <div class="marged">\n        <pre class="itemType">(newSelection: Object[], item: Object, ancestors: Object[], neighbours: Object[]) => void</pre>\n        <p>\n            A callback which is fired when the selection is updated (for instance when the user clicks on an item).<br>\n            This method should update the <em><a href="#TreeView#Required properties#selection">selection array</a></em>.\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ selection={ selection } onselection={ onselection } />\n            <script>\n                this.selection = []\n                this.onselection = _ => this.update({ selection : _ })\n            </script>\n        ";
});

    
  

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(523);

exports.default = {
    title: "Optional properties",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
    subs: [{
        title: "display",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "display-prop"
    }, {
        title: "displaytag",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "displaytag-prop"
    }, {
        title: "strategies",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "strategies-prop"
    }, {
        title: "sort",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "sort-prop"
    }, {
        title: "disable",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "disable-prop"
    }, {
        title: "search",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "search-prop"
    }, {
        title: "async",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "async-prop"
    }, {
        title: "dragndrop",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "dragndrop-prop"
    }, {
        title: "openeropts",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "openeropts-prop"
    }, {
        title: "labels",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "labels-prop"
    }, {
        title: "css",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "css-prop"
    }, {
        title: "transition",
        editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/optional-properties/index.js",
        content: "transition-prop"
    }]
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('display-prop', '    <div class="marged">\n        <pre class="itemType">(item: Object, inputs: Object) => string</pre>\n        <p>\n            A custom rendering function. Called for every item, its return value is displayed in the view.<br>\n            The "inputs" argument is an object containing the input properties of the component which is rendering the item.\n        </p>\n        <div class="emphasis">\n            Defaults to the&nbsp;\n            <em><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString" target="_blank" rel="noopener noreferrer">toString</a></em>&nbsp;\n            function.\n\n            <syntax-highlight>item => item.toString()</syntax-highlight>\n        </div>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ display={ display } />\n            <script>\n                // The display function is run for every item in the model.\n                // Here, we choose to display the 'label' property in lower case.\n                this.display = item => item.display.toLowerCase()\n            </script>"; // eslint-disable-line
});

riot.tag2('displaytag-prop', '    <div class="marged">\n        <pre class="itemType">(item: Object, inputs: Object) => string</pre>\n        <p>\n            <em>The display and displaytag properties are mutually exclusive.</em><br>\n            <br>\n            Allows more customization than the display property, by wrapping items inside a custom tag.<br>\n        </p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n        <TreeView /* ... */ displaytag={ displaytag } />\n\n        <script>\n            // A custom defined tag used to wrap items in an anchor tag\n            // opts.item is a reference to the displayed item\n            riot.tag(\"customtag\", \"<a href={\xA0opts.item.link }>{ opts.item.label }</a>\")\n            this.displaytag = () => \"customtag\"\n        </script>"; // eslint-disable-line
});

riot.tag2('strategies-prop', '    <div class="marged">\n        <pre class="itemType">{strategies}</pre>\n        <p>\n            <em>Strategies determine the action(s) to perform on click, fold or selection.</em><br><br>\n            The <em>strategies prop</em> is an object containing 3 properties (click, fold, selection). Each property value is an array of strategies.<br>\n            A <em>strategy</em> is either a string (containing a predefined strategy name), or a function (executed in the tree context).<br><br>\n            In case of multiple strategies, they are chained.\n        </p>\n\n        <syntax-highlight language="typescript">{parent.type}</syntax-highlight>\n\n        <div class="emphasis">\n            Defaults to :\n            <syntax-highlight>{parent.default}</syntax-highlight>\n        </div>\n\n        <syntax-highlight>{parent.code}</syntax-highlight>\n\n        <p>Check the <em><a href="https://github.com/elbywan/bosket/blob/master/src/core/strategies.js" target="_blank" rel="noopener noreferrer">strategies.js file</a></em> for the list of available strategies and descriptions.</p>\n    </div>\n', '', '', function(opts) {
"use strict";

var _templateObject = _taggedTemplateLiteralLoose(["\n            {\n                selection: (string | selectionStrategy)[],\n                click: (string | clickStrategy)[],\n                fold: (string | foldStrategy)[]\n            }\n        "], ["\n            {\n                selection: (string | selectionStrategy)[],\n                click: (string | clickStrategy)[],\n                fold: (string | foldStrategy)[]\n            }\n        "]);

var _tools = __webpack_require__(16);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

this.strategies = (0, _tools.indent)(_templateObject);
this.type = "\n            type selectionStrategy<Item extends Object> = (item: Item, selection: Array<Item>, neighbours: Array<Item>, ancestors: Array<Item>) => Array<Item>\n            type clickStrategy<Item extends Object> = (item: Item, event: MouseEvent, ancestors: Array<Item>, neighbours: Array<Item>) => void\n            type foldStrategy<Item extends Object> = (item: Item, folded: boolean) => boolean";
this.default = "\n            {\n                // One item selected at a time\n                selection: [\"single\"],\n                // Select item on click\n                click: [\"select\"],\n                // Folds an item when itself or its children are not selected\n                fold: [ \"not-selected\", \"no-child-selection\" ]\n            }";
this.code = "\n            <TreeView /* ... */ strategies={ strategies } />\n\n            <script>\n                this.strategies = {\n                    // Select only the items beginning with the letter a\n                    selection: [ \"multiple\", (item, selection) => selection.filter(elt => elt.label.charAt(0) === 'a' ) ]\n                    click: [ \"select\", unfold-on-selection\" ],\n                    fold: [ \"opener-control\", \"no-child-selection\" ]\n                }\n            </script> // eslint-disable-line\n        ";
});

riot.tag2('sort-prop', '    <div class="marged">\n        <pre class="itemType">(item1, item2) => boolean</pre>\n        <p>A custom sorting function.</p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ sort={ sort } />\n            <script>\n                this.sort = (a, b) => a.label.localeCompare(b.label)\n            </script>";
});

riot.tag2('disable-prop', '    <div class="marged">\n        <pre class="itemType">(item: Object) => boolean</pre>\n        <p>Disables elements based on the result of the provided function, which prevents selection and apply the css \'disabled\' class.</p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ disable={\xA0disable } />\n            <script>\n                this.disable = item => !item.children\n            </script>";
});

riot.tag2('search-prop', '    <div class="marged">\n        <pre class="itemType">(query: string) => (item: Object) => boolean</pre>\n        <p>If provided, enables the built-in search bar and is called when the user types a search query.</p>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ search={\xA0search } />\n            <script>\n                this.search = input => item => item.label.match(new RegExp(`.*${ input }.*`, \"gi\"))\n            </script>";
});

riot.tag2('async-prop', '    <div class="marged">\n        <pre class="itemType">(mixed => Promise&lt;Object[]&gt;) => Promise&lt;Object[]&gt;</pre>\n        <p>A function used to unwrap <em><a href="https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Promise" target="_blank" rel="noopener noreferrer">Promises</a></em> in case of asynchronous children.</p>\n\n        <div class="emphasis">\n            Defaults to simple method call :\n            <syntax-highlight>_ => _()</syntax-highlight>\n        </div>\n\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ async={\xA0async } model={ model } />\n\n            <script>\n                this.model = [{\n                    label: \"Asynchronous children\",\n                    children: timer =>\n                         new Promise(resolve =>\n                            setTimeout(() =>\n                                resolve([{ label: \"timer is provided by the async property\" }]), timer))\n                }]\n                this.async = _ => _(Math.random() * 1000 + 500)\n            </script>";
});

riot.tag2('dragndrop-prop', '    <div class="marged">\n        <pre class="itemType">Object (details below)</pre>\n        <p>The drag\'n\'drop configuration object.</p>\n\n        <div class="emphasis">\n            Defaults to :\n            <syntax-highlight>{parent.default}</syntax-highlight>\n        </div>\n\n\n        <p>Tip: for mobile drag\'n\'drop, use a <em><a target="_blank" rel="noopener noreferrer" href="https://github.com/Bernardo-Castilho/dragdroptouch">polyfill</a></em>.</p>\n\n        <syntax-highlight>{parent.code}</syntax-highlight>\n\n        <p>Example of a draggable tree associated with a droppable tree :</p>\n\n        <dragtree></dragtree>\n        <droptree></droptree>\n\n        <syntax-highlight>{parent.dragdroptrees}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.default = "\n            dragndrop: {\n                draggable: false, // make items draggable\n                droppable: false, // make the tree droppable\n                drag:      null,  // action to perform on drag\n                over:      null,  // hook on dragover\n                enter:     null,  // hook on dragenter\n                leave:     null,  // hook on dragleave\n                drop:      null,  // action to perform on drop\n                cancel:    null,  // action to perform on cancellation\n                guard:     null   // prevents dragover and drop\n            }\n        ";

this.code = "\n            /* [Drag'n'drop presets](https://github.com/elbywan/bosket/blob/master/src/core/dragndrop.js) */\n\n            <TreeView /* ... */ dragndrop={\xA0dragndrop }/>\n\n            <script>\n                this.dragndrop = {\n                    // To drag or drop on specific items\n                    // you can use a function : (item) => true/false\n                    draggable: true,\n                    droppable: true,\n\n                    // target       -> the model item targeted by the event\n                    // event        -> the dragndrop event\n                    // inputs       -> props of the component where the event is triggered\n\n                    drag: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    over: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    enter: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    leave: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    drop: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    cancel: (target, event, inputs) => {\n                        /* ... */\n                    },\n                    guard: (target, event, inputs) => {\n                        /* ... */\n                    }\n                }\n            </script>\n        ";

this.dragdroptrees = "\n            <DragTree>\n                <div class=\"tree-sample\">\n                    <TreeView opts={ conf } />\n                </div>\n                <script>\n                    import { dragndrop } from \"@bosket/core\"\n                    this.dragModel = [\n                        { name: \"< Drag these items >\" },\n                        { name: 1, children: [{ name: 11 }, { name: 12 }, { name: 13 }]},\n                        { name: 2, children: [{ name: 21 }, { name: 22 }]},\n                        { name: 3 },\n                        { name: 4 }\n                    ]\n                    this.conf = {\n                        model: this.dragModel,\n                        category: \"children\",\n                        selection: [],\n                        onselection: _ => this.update({ selection: _ }),\n                        display: i => i.name,\n                        strategies: { fold: [() => false]},\n                        // Pluck preset\n                        dragndrop: { ...dragndrop.pluck(() => this.conf.model, m => {\xA0this.conf.model = m; this.update() }) }\n                    }\n                </script>\n            </DragTree>\n\n            <DropTree>\n                <div class=\"tree-sample\">\n                    <TreeView opts={ conf } />\n                </div>\n                <script>\n                    import { dragndrop } from \"@bosket/core\"\n                    this.conf = {\n                        model: [{ name: \"< Drop items here >\", children: []}],\n                        category: \"children\",\n                        selection: [],\n                        onselection: _ => this.update({ selection: _ }),\n                        display: i => i.name,\n                        strategies: { fold: [() => false]},\n                        // Paste preset + only drop on items with children\n                        dragndrop: {\n                            ...dragndrop.paste(() => this.conf.model, m => {\xA0this.conf.model = m; this.update() }),\n                            droppable: item => item && item.children\n                        }\n                    }\n                </script>\n            </DropTree>\n        ";
});

riot.tag2('dragtree', '    <div class="tree-sample">\n        <treeview opts="{conf}"></treeview>\n    </div>\n', '', '', function(opts) {
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _core = __webpack_require__(9);

this.dragModel = [{ name: "< Drag these items >" }, { name: 1, children: [{ name: 11 }, { name: 12 }, { name: 13 }] }, { name: 2, children: [{ name: 21 }, { name: 22 }] }, { name: 3 }, { name: 4 }];
this.conf = {
    model: this.dragModel,
    category: "children",
    selection: [],
    onselection: function onselection(_) {
        return _this.update({ selection: _ });
    },
    display: function display(i) {
        return i.name;
    },
    strategies: { fold: [function () {
            return false;
        }] },
    // Pluck preset
    dragndrop: _extends({}, _core.dragndrop.pluck(function () {
        return _this.conf.model;
    }, function (m) {
        _this.conf.model = m;_this.update();
    }))
};
});

riot.tag2('droptree', '    <div class="tree-sample">\n        <treeview opts="{conf}"></treeview>\n    </div>\n', '', '', function(opts) {
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _core = __webpack_require__(9);

this.conf = {
    model: [{ name: "< Drop items here >", children: [] }],
    category: "children",
    selection: [],
    onselection: function onselection(_) {
        return _this.update({ selection: _ });
    },
    display: function display(i) {
        return i.name;
    },
    strategies: { fold: [function () {
            return false;
        }] },
    // Paste preset + only drop on items with children
    dragndrop: _extends({}, _core.dragndrop.paste(function () {
        return _this.conf.model;
    }, function (m) {
        _this.conf.model = m;_this.update();
    }), {
        droppable: function droppable(item) {
            return item && item.children;
        }
    })
};
});

riot.tag2('openeropts-prop', '    <div class="marged">\n        <pre class="itemType">{\'{ position: ⁗none⁗ | ⁗left⁗ | ⁗right⁗ }, callback: (item, folded) => void }\'}</pre>\n        <p>\n            A collection of options used to configure the opener, which is usually the little arrow or arrow-like icon used to unfold a node..<br>\n            <br>\n            <strong>position</strong> : Positions the opener.<br>\n            <strong>callback</strong> : Perform a callback when an opener is activated.\n        </p>\n        <div class="emphasis">Defaults to "right"</div>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ openeropts={ openeropts } />\n\n            <script>\n                this.openeropts = {\n                    position: \"left\",\n                    callback: (item, folded) => {\n                        console.log(`${item} is now ${folded ? 'folded' : 'unfolded'}`)\n                    }\n                }\n            </script>\n        ";
});

riot.tag2('labels-prop', '    <div class="marged">\n        <pre class="itemType">Object</pre>\n        <p>Labels override.</p>\n        <div class="emphasis">\n            Defaults to :\n            <syntax-highlight>{parent.default}</syntax-highlight>\n        </div>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.default = "\n            labels: {\n                \"search.placeholder\": \"Search ...\"\n            }\n        ";
this.code = "\n            <TreeView /* ... */ labels={\xA0labels } />\n\n            <script>\n                this.labels = {\n                    \"search.placeholder\": \"I am the text displayed in the search bar as a placeholder.\"\n                }\n            </script>\n        ";
});

riot.tag2('css-prop', '    <div class="marged">\n        <pre class="itemType">Object</pre>\n        <p>Css classnames override.</p>\n        <div class="emphasis">\n            Defaults to :\n            <syntax-highlight>{parent.default}</syntax-highlight>\n        </div>\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.default = "\n            css: {\n                TreeView:           \"TreeView\",\n                opener:             \"opener\",\n                depth:              \"depth\",\n                selected:           \"selected\",\n                category:           \"category\",\n                folded:             \"folded\",\n                disabled:           \"disabled\",\n                async:              \"async\",\n                loading:            \"loading\",\n                nodrop:             \"nodrop\",\n                dragover:           \"dragover\",\n                search:             \"search\",\n                item:               \"item\"\n            }\n        ";
this.code = "\n            <TreeView /* ... */ css={ css } />\n\n            <script>\n                this.css = { TreeView: \"CustomTree\", loading: \"customLoading\" }\n            </script>\n        ";
});

riot.tag2('transition-prop', '    <div class="marged">\n        <pre class="itemType">Object</pre>\n        <p>\n            Allows transitions by <em><a href="https://github.com/elbywan/bosket/blob/master/src/riot/mixins/transition.js">applying css classes on mount/unmount</a></em>.<br>\n        </p>\n\n        <syntax-highlight>{parent.code}</syntax-highlight>\n    </div>\n', '', '', function(opts) {
"use strict";

this.code = "\n            <TreeView /* ... */ transition={ transition } />\n\n            <style>\n                .TransitionName {\n                    transition: opacity .3s;\n                }\n                .TransitionName-mount, .TransitionName-unmount {\n                    opacity: 0;\n                }\n            </style>\n            <script>\n                /*\n                    During the whole life of the tree, the \"TransitionName\" css class\n                        is set on the element.\n                    On mount the  \"TransitionName-mount\" css class is applied,\n                        then removed next tick.\n                    On unmount the  \"TransitionName-unmount\" css class is applied,\n                        and the node destruction is delayed until the transition completes.\n                 */\n                this.transition = {\n                     name: \"TransitionName\"\n                }\n            </script>\n        ";
});

    
  

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('syntax-highlight', '    <pre class="{⁗language-⁗ + language}"><code class="{⁗language-⁗ + language}" ref="ref"><yield></yield></code></pre>\n', '', '', function(opts) {
"use strict";

var _this = this;

var _tools = __webpack_require__(16);

this.language = this.opts.language || "javascript";

var makePrefix = function makePrefix(i) {
    var str = "";
    for (var _ = 0; _ < i; _++) {
        str += " ";
    }
    return str;
};
var offsetPrefix = this.opts.offset ? makePrefix(this.opts.offset) : "";
this.one("mount", function () {
    _this.refs.ref.textContent = (0, _tools.indent)(offsetPrefix + (_this.opts.content || _this.refs.ref.textContent));
    window.Prism.highlightElement(_this.refs.ref);
});
});

    
  

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('componentdemo', '    <div class="ComponentDemo section">\n        <h3 if="{componentname}">{componentname}</h3>\n        <p if="{description}">{description}</p>\n        <div class="{ComponentDemo: true, ⁗flex-container⁗: true, expanded: expand}">\n            <div class="{ComponentDemo: true, ⁗demo-area⁗: true, expand: expand === ⁗demo⁗}">\n\n                <div class="ComponentDemo expander" onclick="{doExpand(⁗demo⁗)}">\n                    <i class="{fa: true,                         ⁗fa-compress⁗:  expand === ⁗demo⁗,                         ⁗fa-expand⁗:    expand !== ⁗demo⁗}"></i>\n                </div>\n\n                <div class="ComponentDemo padded">\n                    <yield></yield>\n                </div>\n            </div>\n            <div class="{ComponentDemo: true, code: true, expand: expand === ⁗code⁗}">\n\n                <div class="ComponentDemo expander" onclick="{doExpand(⁗code⁗)}">\n                    <i class="{fa: true,                         ⁗fa-compress⁗:  expand === ⁗code⁗,                         ⁗fa-expand⁗:    expand !== ⁗code⁗}"></i>\n                </div>\n\n                <div class="tabs">\n                    <div each="{file in files}" onclick="{setTab(file)}" class="{selected: parent.tab === file}">\n                        {getFileName(file)}\n                    </div>\n                </div>\n\n                <pre class="{⁗language-⁗ + getPrismExtension(tab)}"><code class="{⁗language-⁗ + getPrismExtension(tab)}" ref="tabContents"></code></pre>\n            </div>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

__webpack_require__(71);

var _tools = __webpack_require__(16);

Object.assign(this, this.opts);
if (!this.files) this.files = [];

this.expand = "demo";
this.doExpand = function (target) {
    return function (_) {
        return _this.expand = _this.expand === target ? "" : target;
    };
};

this._tab = null;
this.setTab = function (file) {
    return function (e) {
        return _this.tab = file;
    };
};
Object.defineProperty(this, "tab", {
    configurable: true,
    get: function get() {
        return _this._tab || (_this.files.length > 0 ? _this.files[0] : null);
    },
    set: function set(file) {
        _this._tab = file;
        (0, _tools.loadFile)(file, function (code) {
            _this.refs.tabContents.innerHTML = window["Prism"].highlight(code, window["Prism"].languages[_this.getPrismExtension(file)]);
        });
    }
});
this.tab = this.files.length > 0 ? this.files[0] : null;

this.getFileName = function (file) {
    return file.split("/").splice(-1);
};
this.getPrismExtension = function (file) {
    var split = file.split(".");
    var extension = "javascript";
    if (split[split.length - 1] === "css") extension = "css";else if (split[split.length - 1] === "ts") extension = "typescript";
    return extension;
};
});

    
  

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(527);

__webpack_require__(531);

__webpack_require__(534);

__webpack_require__(537);

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(528);

__webpack_require__(530);

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeviewdemo', '\n    <treeview opts="{options}" selection="{opts.selection}" onselection="{opts.onselection}"></treeview>\n', '', '', function(opts) {
"use strict";

var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Model

// Style

var _tools = __webpack_require__(10);

var _core = __webpack_require__(9);

var _riot = __webpack_require__(6);

var _riot2 = _interopRequireDefault(_riot);

var _TreeViewModel = __webpack_require__(81);

var _TreeViewModel2 = _interopRequireDefault(_TreeViewModel);

__webpack_require__(529);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.dragImage = new Image();
this.dragImage.src = "../assets/drag-image.png";

// A custom defined tag used to wrap items on display
_riot2.default.tag("wrappedlabel", "<a>{ opts.item.label }</a>");

this.options = {
    // Data model
    model: _TreeViewModel2.default,
    // Property of the model containing children
    category: "items",
    // Wrapper tag
    displaytag: function displaytag(item) {
        return "wrappedlabel";
    },
    // Alphabetical sort
    sort: function sort(a, b) {
        return a.label.localeCompare(b.label);
    },
    // Search by regex
    search: function search(input) {
        return function (i) {
            return (0, _tools.string)(i.label).contains(input);
        };
    },
    strategies: {
        // Select on click
        click: ["select"],
        // Use keyboard modifiers
        selection: ["modifiers"],
        // Use the opener to control element folding
        fold: ["opener-control"]
    },
    // Custom css root class name
    css: { TreeView: "TreeViewDemo" },
    dragndrop: _extends({}, _core.dragndrop.selection(function () {
        return _this.options.model;
    }, function (m) {
        _this.options.model = m;_this.update();
    }), {
        // Add a custom image on drag
        drag: function drag(_, event) {
            event.dataTransfer.setDragImage(_this.dragImage, 0, 0);
            event.dataTransfer.setData("application/json", JSON.stringify(_this.options.selection));
        },
        // Drop only on categories or root (excluding asynchronous promises)
        droppable: function droppable(_) {
            return !_ || _.items && _.items instanceof Array;
        }
    }),
    // Allow css transitions on mount/unmount
    transition: {
        name: "TreeViewDemoTransition"
    }
};
});

    
  

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('treeviewsection', '    <div>\n        <p>\n            <span>Demonstrates a basic usage of the TreeView component </span>\n            <span>and how to override and use most of its </span>\n            <em><a href="#TreeView#Required properties">component props</a></em>, and&nbsp;\n            <em><a href="#TreeView#Css">css styles</a></em>.\n        </p>\n        <span>Featuring :</span>\n        <ul>\n            <li>Drag and drop, with a custom drag image.</li>\n            <li>Asynchronous children loading</li>\n            <li>Multiselection using keyboard modifiers (shift / ctrl or cmd)</li>\n            <li>Transitions on fold / unfold</li>\n            <li>Alphabetical sort</li>\n            <li>Search bar</li>\n        </ul>\n    </div>\n    <componentdemo componentname="Nested items" files="{files}">\n        <div class="TreeViewWindow">\n            <div style="display: inline-block; text-align: left">\n                <treeviewdemo selection="{parent.selection}" onselection="{parent.onselection}"></TreeViewDemo>\n            </div>\n\n            <p>\n                <span if="{parent.selection.length === 0}">No elements are</span>\n                <span if="{parent.selection.length === 1}">One element is</span>\n                <span if="{parent.selection.length > 1}">{parent.selection.length} elements are</span>\n                selected.\n            </p>\n\n            <div class="select-blocks">\n                <button each="{item in parent.selection}" onclick="{parent.parent.deselect(item)}">\n                    {item.label}\n                </button>\n            </div>\n        </div>\n    </ComponentDemo>\n', '', '', function(opts) {
"use strict";

var _this = this;

__webpack_require__(82);

this.files = ["./components/Demos/TreeView/TreeViewDemo.tag", "./components/Demos/TreeView/TreeViewDemo.css", "../common/models/TreeViewModel.js"];

this.selection = [];
this.onselection = function (_) {
    return _this.update({ selection: _ });
};
this.deselect = function (item) {
    return function (_) {
        return _this.selection = _this.selection.filter(function (i) {
            return i !== item;
        });
    };
};
});

    
  

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(532);

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('chucknorriscategory', '    <span class="value">{item.value}\n        <i class="{⁗fa fa-refresh⁗ + (item.children.length === 0 ? ⁗ loading⁗ : ⁗⁗)}" onclick="{onClick}">\n        </i>\n    </span>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.item = this.opts.item;
this.onClick = function (e) {
    _this.item.children = [];
    _this.item.loadJoke().then(function (joke) {
        _this.item.children = joke;
        _this.parent.update();
    });
};
});

riot.tag2('chucknorrisjoke', '    <div class="value">\n        <a href="{item.url}" target="_blank" rel="noopener noreferrer">{item.value}</a>\n    </div>\n', '', '', function(opts) {
"use strict";

this.item = this.opts.item;
});

riot.tag2('chucknorris', '    <div>\n       <div style="text-align: center; margin: 10px;">\n           <div>\n               <a href="https://api.chucknorris.io/" target="_blank" rel="noopener noreferrer">\n                   <img src="https://assets.chucknorris.host/img/chucknorris_logo_coloured_small.png" alt="Chuck Norris api logo" style="width: 100px; filter: drop-shadow(0 0 2px #444);">\n               </a>\n           </div>\n           <h5>A curated list of Chuck Norris jokes.</h5>\n           <div>\n               <button onclick="{init}" class="ChuckNorrisButton">Reset</button>\n           </div>\n            <i if="{categories.length === 0}" class="ChuckNorrisSpinner fa fa-spinner fa-3x"></i>\n       </div>\n       <treeview if="{categories.length > 0}" model="{categories}" category="children" selection="{selection}" onselection="{onselection}" displaytag="{display}" strategies="{conf.strategies}" css="{conf.css}"></treeview>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

__webpack_require__(72);

var _models = __webpack_require__(533);

this.categories = [];
this.selection = [];
this.onselection = function (_) {
    return _this.update({ selection: _ });
};
this.conf = {
    strategies: { fold: ["opener-control"], click: ["unfold-on-selection"] },
    css: { TreeView: "ChuckNorrisDemo" }
};
this.init = function () {
    fetch("https://api.chucknorris.io/jokes/categories").then(function (response) {
        return response.json();
    }).then(function (categories) {
        _this.categories = categories.map(function (cat) {
            return new _models.Category(cat);
        });
        _this.update();
    });
};
this.one("mount", this.init);
this.display = function (item) {
    return item.display();
};
});

    
  

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Category = exports.Category = function Category(category) {
    var _this = this;

    _classCallCheck(this, Category);

    this.loadJoke = function () {
        return fetch("https://api.chucknorris.io/jokes/random?category=" + _this.value).then(function (response) {
            return response.json();
        }).then(function (joke) {
            return [new Joke(joke)];
        });
    };

    this.display = function () {
        return "chucknorriscategory";
    };

    this.value = category;
    this.children = this.loadJoke;
}

// Riotjs tags are lowercased by the compiler
;

var Joke = exports.Joke = function Joke(joke) {
    _classCallCheck(this, Joke);

    this.display = function () {
        return "chucknorrisjoke";
    };

    Object.assign(this, joke);
}
// Riotjs tags are lowercased by the compiler
;

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(535);

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('hackernewsfetchmore', '    <div class="fetchMore" onclick="{more}">\n        <a>Load more comments</a>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.more = function (e) {
    _this.opts.item.fetchKids().then(_this.parent.parent.update);
};
});

riot.tag2('hackernewstopstories', '    <span class="story">\n        <span class="commentCount"><span if="{item.descendants}">({item.descendants}) </span>({item.score} points) - by <a href="{⁗https://news.ycombinator.com/user?id=⁗ + item.by}" target="_blank" rel="noopener noreferrer">{item.by}</a></span>\n        <a href="{item.url}" target="_blank" rel="noopener noreferrer">\n            {item.title}\n        </a>\n    </span>\n', '', '', function(opts) {
"use strict";

this.item = this.opts.item;
});

riot.tag2('hackernewscomment', '    <div class="comment">\n        <div class="infobar">\n            <span class="commentCount" if="{item.kids && item.kids.length > 0}">({item.kids.length})</span>\n            <a href="{⁗https://news.ycombinator.com/user?id=⁗ + item.by}" target="_blank" rel="noopener noreferrer">{item.by}</a> {item.date}\n        </div>\n        <div class="text" if="{item.deleted}"><em>Deleted.</em></div>\n        <div class="text" if="{!item.deleted}" ref="content"></div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

this.item = this.opts.item;
var refreshContent = function refreshContent() {
        return _this.refs.content.innerHTML = _this.item.text;
};
this.on("update", refreshContent);
this.one("mount", refreshContent);
});

riot.tag2('hackernews', '    <div>\n        <div style="text-align: center; margin: 10px;">\n            <div>\n                <a href="https://news.ycombinator.com" target="_blank" rel="noopener noreferrer">\n                    <img src="http://www.ycombinator.com/images/ycombinator-logo-fb889e2e.png" alt="HackerNews logo" style="width: 50px; filter: drop-shadow(0 0 2px #444);">\n                </a>\n            </div>\n            <h5>The top 10 stories from HackerNews.</h5>\n            <div>\n                <button onclick="{init}" class="HackerNewsButton">Reset</button>\n            </div>\n            <i if="{stories.length === 0}" class="HackerNewsSpinner fa fa-spinner fa-3x"></i>\n        </div>\n        <treeview if="{stories.length > 0}" model="{stories}" category="children" selection="{selection}" onselection="{onselection}" displaytag="{display}" strategies="{conf.strategies}" css="{conf.css}"></TreeView>\n    </div>\n', '', '', function(opts) {
"use strict";

var _this = this;

__webpack_require__(73);

var _models = __webpack_require__(536);

this.stories = [];
this.selection = [];
this.onselection = function (_) {
    return _this.update({ selection: _ });
};
this.conf = {
    strategies: { fold: ["opener-control"] },
    css: { TreeView: "HackerNewsDemo" }
};
this.display = function (item) {
    return item.display();
};

this.init = function () {
    fetch("https://hacker-news.firebaseio.com/v0/beststories.json").then(function (response) {
        return response.json();
    }).then(function (topStories) {
        return (0, _models.fetchLast)(topStories, function (_) {
            return "https://hacker-news.firebaseio.com/v0/item/" + _ + ".json";
        });
    }).then(function (topStories) {
        _this.stories = topStories.map(function (story) {
            return new _models.TopStory(story);
        });
        _this.update();
    });
};
this.one("mount", this.init);
});

    
  

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Comment = exports.TopStory = exports.fetchLast = undefined;

var _sanitizeHtml = __webpack_require__(74);

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fetchLast = exports.fetchLast = function fetchLast(arr, getUrl) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return Promise.all(arr.slice(offset, offset + limit).map(function (_) {
        return fetch(getUrl(_)).then(function (response) {
            return response.json();
        });
    }));
};

var Item = function () {
    function Item(data) {
        var _this = this;

        _classCallCheck(this, Item);

        this.offset = 0;
        this.fetchLimit = 5;

        Object.assign(this, data);
        if (this.kids) {
            this.children = function () {
                return _this.fetchKids();
            };
        }
    }

    Item.prototype.fetchKids = function fetchKids() {
        var _this2 = this;

        if (this.children instanceof Array && this.children[this.children.length - 1].id === -1) this.children = this.children.slice(0, this.children.length - 1);
        return fetchLast(this.kids, function (_) {
            return "https://hacker-news.firebaseio.com/v0/item/" + _ + ".json";
        }, this.fetchLimit, this.offset).then(function (kids) {
            var result = kids.map(function (k) {
                return new Comment(k);
            });
            _this2.offset += _this2.fetchLimit;
            if (_this2.offset < _this2.kids.length) {
                result.push({
                    id: -1,
                    fetchKids: function fetchKids() {
                        return _this2.fetchKids().then(function (_) {
                            if (_this2.children instanceof Array) _this2.children = [].concat(_this2.children, _);
                        });
                    },
                    // Riotjs tags are lowercased by the compiler
                    display: function display() {
                        return "hackernewsfetchmore";
                    }
                });
            }
            return result;
        });
    };

    return Item;
}();

var TopStory = exports.TopStory = function (_Item) {
    _inherits(TopStory, _Item);

    function TopStory() {
        var _temp, _this3, _ret;

        _classCallCheck(this, TopStory);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _Item.call.apply(_Item, [this].concat(args))), _this3), _this3.display = function () {
            return "hackernewstopstories";
        }, _temp), _possibleConstructorReturn(_this3, _ret);
    }
    // Riotjs tags are lowercased by the compiler


    return TopStory;
}(Item);

var Comment = exports.Comment = function (_Item2) {
    _inherits(Comment, _Item2);

    function Comment(data) {
        _classCallCheck(this, Comment);

        var _this4 = _possibleConstructorReturn(this, _Item2.call(this, data));

        _this4.display = function () {
            return "hackernewscomment";
        };

        _this4.text = (0, _sanitizeHtml2.default)(_this4.text);
        _this4.date = new Date(_this4.time * 1000).toLocaleDateString();
        return _this4;
    }

    // Riotjs tags are lowercased by the compiler


    return Comment;
}(Item);

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(538);

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(6)
    riot.tag2('pokeapisubcategory', '    <span class="subcategory">{opts.item.name}</span>\n', '', '', function(opts) {
});

riot.tag2('pokeapiitem', '    <div class="{subsection : opts.item.__subsection}">\n        <img if="{opts.item.__image}" riot-src="{opts.item.__image}" alt="sprite">\n        <div class="property-row" each="{prop in filterProps()}">\n            <label>{prop}</label><span>{⁗⁗ + parent.opts.item[prop]}</span>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _this = this;

this.filterProps = function () {
    var props = Object.getOwnPropertyNames(_this.opts.item);
    return props.filter(function (prop) {
        return !prop.startsWith("__") && !(_typeof(_this[prop]) === "object") && !(typeof _this[prop] === "function");
    });
};
});

riot.tag2('pokemondisplay', '    <virtual>{opts.item.name} </virtual>\n', '', '', function(opts) {
});

riot.tag2('pokeapi', '    <div style="position: relative;">\n        <div style="text-align: center; margin: 10px;">\n            <div>\n                <a href="https://pokeapi.co/" target="_blank" rel="noopener noreferrer">\n                    <img src="https://avatars3.githubusercontent.com/u/19692032?v=4&s=200" alt="Pokéapi logo" style="width: 50px; filter: drop-shadow(0 0 2px #444);">\n                </a>\n            </div>\n            <h5>Pokémon API crawler</h5>\n            <div>\n                <button onclick="{init}" class="PokeapiButton">Reset</button>\n            </div>\n        </div>\n        <treeview model="{data}" category="__children" selection="{selection}" onselection="{onselection}" displaytag="{display}" strategies="{conf.strategies}" css="{conf.css}" disable="{conf.disable}" search="{conf.search}"></treeview>\n        <div class="{PokeapiLoadMore: true, ⁗center-text⁗: true, loading: loading}" riot-style="{⁗display:⁗ + loadUrl ? ⁗block⁗ : ⁗none⁗}" onclick="{loadMorePokemons}">\n            <i class="fa fa-spinner fa-2x" if="{loading}"></i>\n            <span if="{!loading}">Show more pokémons</span>\n        </div>\n    </div>\n', '', '', function(opts) {
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

__webpack_require__(80);

var _models = __webpack_require__(539);

this.conf = {
    strategies: { fold: ["opener-control", function (_) {
            return !_.__subsection;
        }], click: ["toggle-fold"] },
    css: { TreeView: "PokeapiDemo" },
    disable: function disable(_) {
        return _.__children && _.__children instanceof Array && _.__children.length === 0;
    },
    search: function search(input) {
        return function (item) {
            return item.name && item.name.startsWith(input);
        };
    }
};
this.data = [];
this.selection = [];
this.onselection = function (_) {
    return _this.update({ selection: _ });
};
this.loading = false;
this.loadUrl = "https://pokeapi.co/api/v2/pokemon";
this.display = function (item) {
    return item.display();
};

this.init = function () {
    _this.loadUrl = "https://pokeapi.co/api/v2/pokemon";
    _this.loadPokemons().then(function (_) {
        _this.update({ data: _ });
    });
};
this.one("mount", this.init);

this.loadPokemons = function () {
    if (!_this.loadUrl) return;
    _this.loading = true;
    return (0, _models.cachedFetch)(_this.loadUrl).then(function (json) {
        _this.loadUrl = json.next;
        _this.loading = false;
        return json.results.map(function (i) {
            return _extends({}, i, {
                display: function display() {
                    return "pokemondisplay";
                },
                __children: function __children() {
                    return (0, _models.cachedFetch)(i.url).then(function (json) {
                        return [new _models.Item(json)];
                    });
                }
            });
        });
    }).catch(function (err) {
        return _this.loading = false;
    });
};
this.loadMorePokemons = function () {
    if (_this.loading) return;
    _this.loadPokemons().then(function (_) {
        _this.update({ data: [].concat(_this.data, _) });
    });
};
});

    
  

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = exports.Item = function () {
    function Item(data) {
        _classCallCheck(this, Item);

        Object.assign(this, formatData(data));
    }

    Item.prototype.display = function display() {
        return this.name && this.url ? "pokeapisubcategory" : "pokeapiitem";
    };

    return Item;
}();

var cache = new Map();
var cachedFetch = exports.cachedFetch = function cachedFetch(url) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return fetch.apply(undefined, [url].concat(args)).then(function (response) {
        return response.json();
    }).then(function (json) {
        cache.set(url, json);
        return json;
    });
};

var imageMatch = function imageMatch(name, val) {
    return name === "sprites" && val.front_default;
};

var formatData = function formatData(d) {
    var data = _extends({}, d);
    if (data.url) {
        var url = data.url;
        data.__children = function () {
            return cachedFetch(url).then(function (json) {
                return [new Item(json)];
            });
        };
        return data;
    }
    data.__subsection = true;
    for (var prop in data) {
        if (prop.startsWith("__")) continue;

        if (data[prop] instanceof Array) {
            if (!data.__children) data.__children = [];
            data.__children.push({
                name: "" + prop,
                display: function display() {
                    return "pokeapisubcategory";
                },
                __children: data[prop].map(function (_) {
                    return new Item(_);
                })
            });
            delete data[prop];
        } else if (data[prop] && _typeof(data[prop]) === "object") {
            if (!data.__children) data.__children = [];
            if (data[prop].url && data[prop].name) {
                (function () {
                    var name = data[prop].name;
                    var url = data[prop].url;
                    data.__children.push({
                        name: name,
                        display: function display() {
                            return "pokeapisubcategory";
                        },
                        __children: function __children() {
                            return cachedFetch(url).then(function (json) {
                                return [new Item(json)];
                            });
                        }
                    });
                })();
            } else {
                data.__children.push({
                    name: "" + prop,
                    display: function display() {
                        return "pokeapisubcategory";
                    },
                    __children: [new Item(data[prop])]
                });
            }
            var img = imageMatch(prop, data[prop]);
            if (img) data.__image = img;
            delete data[prop];
        }
    }
    return data;
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

/* Riot v3.9.1, @license MIT */
(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.riot = {})));
}(this, (function (exports) { 'use strict';

  /**
   * Shorter and fast way to select a single node in the DOM
   * @param   { String } selector - unique dom selector
   * @param   { Object } ctx - DOM node where the target of our search will is located
   * @returns { Object } dom node found
   */
  function $(selector, ctx) {
    return (ctx || document).querySelector(selector)
  }

  var
    // be aware, internal usage
    // ATTENTION: prefix the global dynamic variables with `__`
    // tags instances cache
    __TAGS_CACHE = [],
    // tags implementation cache
    __TAG_IMPL = {},
    YIELD_TAG = 'yield',

    /**
     * Const
     */
    GLOBAL_MIXIN = '__global_mixin',

    // riot specific prefixes or attributes
    ATTRS_PREFIX = 'riot-',

    // Riot Directives
    REF_DIRECTIVES = ['ref', 'data-ref'],
    IS_DIRECTIVE = 'data-is',
    CONDITIONAL_DIRECTIVE = 'if',
    LOOP_DIRECTIVE = 'each',
    LOOP_NO_REORDER_DIRECTIVE = 'no-reorder',
    SHOW_DIRECTIVE = 'show',
    HIDE_DIRECTIVE = 'hide',
    KEY_DIRECTIVE = 'key',
    RIOT_EVENTS_KEY = '__riot-events__',

    // for typeof == '' comparisons
    T_STRING = 'string',
    T_OBJECT = 'object',
    T_UNDEF  = 'undefined',
    T_FUNCTION = 'function',

    XLINK_NS = 'http://www.w3.org/1999/xlink',
    SVG_NS = 'http://www.w3.org/2000/svg',
    XLINK_REGEX = /^xlink:(\w+)/,

    WIN = typeof window === T_UNDEF ? undefined : window,

    // special native tags that cannot be treated like the others
    RE_SPECIAL_TAGS = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?|opt(?:ion|group))$/,
    RE_SPECIAL_TAGS_NO_OPTION = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?)$/,
    RE_EVENTS_PREFIX = /^on/,
    RE_HTML_ATTRS = /([-\w]+) ?= ?(?:"([^"]*)|'([^']*)|({[^}]*}))/g,
    // some DOM attributes must be normalized
    CASE_SENSITIVE_ATTRIBUTES = {
      'viewbox': 'viewBox',
      'preserveaspectratio': 'preserveAspectRatio'
    },
    /**
     * Matches boolean HTML attributes in the riot tag definition.
     * With a long list like this, a regex is faster than `[].indexOf` in most browsers.
     * @const {RegExp}
     * @see [attributes.md](https://github.com/riot/compiler/blob/dev/doc/attributes.md)
     */
    RE_BOOL_ATTRS = /^(?:disabled|checked|readonly|required|allowfullscreen|auto(?:focus|play)|compact|controls|default|formnovalidate|hidden|ismap|itemscope|loop|multiple|muted|no(?:resize|shade|validate|wrap)?|open|reversed|seamless|selected|sortable|truespeed|typemustmatch)$/,
    // version# for IE 8-11, 0 for others
    IE_VERSION = (WIN && WIN.document || {}).documentMode | 0;

  /**
   * Create a generic DOM node
   * @param   { String } name - name of the DOM node we want to create
   * @returns { Object } DOM node just created
   */
  function makeElement(name) {
    return name === 'svg' ? document.createElementNS(SVG_NS, name) : document.createElement(name)
  }

  /**
   * Set any DOM attribute
   * @param { Object } dom - DOM node we want to update
   * @param { String } name - name of the property we want to set
   * @param { String } val - value of the property we want to set
   */
  function setAttribute(dom, name, val) {
    var xlink = XLINK_REGEX.exec(name);
    if (xlink && xlink[1])
      { dom.setAttributeNS(XLINK_NS, xlink[1], val); }
    else
      { dom.setAttribute(name, val); }
  }

  var styleNode;
  // Create cache and shortcut to the correct property
  var cssTextProp;
  var byName = {};
  var remainder = [];
  var needsInject = false;

  // skip the following code on the server
  if (WIN) {
    styleNode = ((function () {
      // create a new style element with the correct type
      var newNode = makeElement('style');
      // replace any user node or insert the new one into the head
      var userNode = $('style[type=riot]');

      setAttribute(newNode, 'type', 'text/css');
      /* istanbul ignore next */
      if (userNode) {
        if (userNode.id) { newNode.id = userNode.id; }
        userNode.parentNode.replaceChild(newNode, userNode);
      } else { document.head.appendChild(newNode); }

      return newNode
    }))();
    cssTextProp = styleNode.styleSheet;
  }

  /**
   * Object that will be used to inject and manage the css of every tag instance
   */
  var styleManager = {
    styleNode: styleNode,
    /**
     * Save a tag style to be later injected into DOM
     * @param { String } css - css string
     * @param { String } name - if it's passed we will map the css to a tagname
     */
    add: function add(css, name) {
      if (name) { byName[name] = css; }
      else { remainder.push(css); }
      needsInject = true;
    },
    /**
     * Inject all previously saved tag styles into DOM
     * innerHTML seems slow: http://jsperf.com/riot-insert-style
     */
    inject: function inject() {
      if (!WIN || !needsInject) { return }
      needsInject = false;
      var style = Object.keys(byName)
        .map(function (k) { return byName[k]; })
        .concat(remainder).join('\n');
      /* istanbul ignore next */
      if (cssTextProp) { cssTextProp.cssText = style; }
      else { styleNode.innerHTML = style; }
    }
  }

  /**
   * The riot template engine
   * @version v3.0.8
   */

  var skipRegex = (function () { //eslint-disable-line no-unused-vars

    var beforeReChars = '[{(,;:?=|&!^~>%*/';

    var beforeReWords = [
      'case',
      'default',
      'do',
      'else',
      'in',
      'instanceof',
      'prefix',
      'return',
      'typeof',
      'void',
      'yield'
    ];

    var wordsLastChar = beforeReWords.reduce(function (s, w) {
      return s + w.slice(-1)
    }, '');

    var RE_REGEX = /^\/(?=[^*>/])[^[/\\]*(?:(?:\\.|\[(?:\\.|[^\]\\]*)*\])[^[\\/]*)*?\/[gimuy]*/;
    var RE_VN_CHAR = /[$\w]/;

    function prev (code, pos) {
      while (--pos >= 0 && /\s/.test(code[pos])){ }
      return pos
    }

    function _skipRegex (code, start) {

      var re = /.*/g;
      var pos = re.lastIndex = start++;
      var match = re.exec(code)[0].match(RE_REGEX);

      if (match) {
        var next = pos + match[0].length;

        pos = prev(code, pos);
        var c = code[pos];

        if (pos < 0 || ~beforeReChars.indexOf(c)) {
          return next
        }

        if (c === '.') {

          if (code[pos - 1] === '.') {
            start = next;
          }

        } else if (c === '+' || c === '-') {

          if (code[--pos] !== c ||
              (pos = prev(code, pos)) < 0 ||
              !RE_VN_CHAR.test(code[pos])) {
            start = next;
          }

        } else if (~wordsLastChar.indexOf(c)) {

          var end = pos + 1;

          while (--pos >= 0 && RE_VN_CHAR.test(code[pos])){ }
          if (~beforeReWords.indexOf(code.slice(pos + 1, end))) {
            start = next;
          }
        }
      }

      return start
    }

    return _skipRegex

  })();

  /**
   * riot.util.brackets
   *
   * - `brackets    ` - Returns a string or regex based on its parameter
   * - `brackets.set` - Change the current riot brackets
   *
   * @module
   */

  /* global riot */

  /* istanbul ignore next */
  var brackets = (function (UNDEF) {

    var
      REGLOB = 'g',

      R_MLCOMMS = /\/\*[^*]*\*+(?:[^*\/][^*]*\*+)*\//g,

      R_STRINGS = /"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'|`[^`\\]*(?:\\[\S\s][^`\\]*)*`/g,

      S_QBLOCKS = R_STRINGS.source + '|' +
        /(?:\breturn\s+|(?:[$\w\)\]]|\+\+|--)\s*(\/)(?![*\/]))/.source + '|' +
        /\/(?=[^*\/])[^[\/\\]*(?:(?:\[(?:\\.|[^\]\\]*)*\]|\\.)[^[\/\\]*)*?([^<]\/)[gim]*/.source,

      UNSUPPORTED = RegExp('[\\' + 'x00-\\x1F<>a-zA-Z0-9\'",;\\\\]'),

      NEED_ESCAPE = /(?=[[\]()*+?.^$|])/g,

      S_QBLOCK2 = R_STRINGS.source + '|' + /(\/)(?![*\/])/.source,

      FINDBRACES = {
        '(': RegExp('([()])|'   + S_QBLOCK2, REGLOB),
        '[': RegExp('([[\\]])|' + S_QBLOCK2, REGLOB),
        '{': RegExp('([{}])|'   + S_QBLOCK2, REGLOB)
      },

      DEFAULT = '{ }';

    var _pairs = [
      '{', '}',
      '{', '}',
      /{[^}]*}/,
      /\\([{}])/g,
      /\\({)|{/g,
      RegExp('\\\\(})|([[({])|(})|' + S_QBLOCK2, REGLOB),
      DEFAULT,
      /^\s*{\^?\s*([$\w]+)(?:\s*,\s*(\S+))?\s+in\s+(\S.*)\s*}/,
      /(^|[^\\]){=[\S\s]*?}/
    ];

    var
      cachedBrackets = UNDEF,
      _regex,
      _cache = [],
      _settings;

    function _loopback (re) { return re }

    function _rewrite (re, bp) {
      if (!bp) { bp = _cache; }
      return new RegExp(
        re.source.replace(/{/g, bp[2]).replace(/}/g, bp[3]), re.global ? REGLOB : ''
      )
    }

    function _create (pair) {
      if (pair === DEFAULT) { return _pairs }

      var arr = pair.split(' ');

      if (arr.length !== 2 || UNSUPPORTED.test(pair)) {
        throw new Error('Unsupported brackets "' + pair + '"')
      }
      arr = arr.concat(pair.replace(NEED_ESCAPE, '\\').split(' '));

      arr[4] = _rewrite(arr[1].length > 1 ? /{[\S\s]*?}/ : _pairs[4], arr);
      arr[5] = _rewrite(pair.length > 3 ? /\\({|})/g : _pairs[5], arr);
      arr[6] = _rewrite(_pairs[6], arr);
      arr[7] = RegExp('\\\\(' + arr[3] + ')|([[({])|(' + arr[3] + ')|' + S_QBLOCK2, REGLOB);
      arr[8] = pair;
      return arr
    }

    function _brackets (reOrIdx) {
      return reOrIdx instanceof RegExp ? _regex(reOrIdx) : _cache[reOrIdx]
    }

    _brackets.split = function split (str, tmpl, _bp) {
      // istanbul ignore next: _bp is for the compiler
      if (!_bp) { _bp = _cache; }

      var
        parts = [],
        match,
        isexpr,
        start,
        pos,
        re = _bp[6];

      var qblocks = [];
      var prevStr = '';
      var mark, lastIndex;

      isexpr = start = re.lastIndex = 0;

      while ((match = re.exec(str))) {

        lastIndex = re.lastIndex;
        pos = match.index;

        if (isexpr) {

          if (match[2]) {

            var ch = match[2];
            var rech = FINDBRACES[ch];
            var ix = 1;

            rech.lastIndex = lastIndex;
            while ((match = rech.exec(str))) {
              if (match[1]) {
                if (match[1] === ch) { ++ix; }
                else if (!--ix) { break }
              } else {
                rech.lastIndex = pushQBlock(match.index, rech.lastIndex, match[2]);
              }
            }
            re.lastIndex = ix ? str.length : rech.lastIndex;
            continue
          }

          if (!match[3]) {
            re.lastIndex = pushQBlock(pos, lastIndex, match[4]);
            continue
          }
        }

        if (!match[1]) {
          unescapeStr(str.slice(start, pos));
          start = re.lastIndex;
          re = _bp[6 + (isexpr ^= 1)];
          re.lastIndex = start;
        }
      }

      if (str && start < str.length) {
        unescapeStr(str.slice(start));
      }

      parts.qblocks = qblocks;

      return parts

      function unescapeStr (s) {
        if (prevStr) {
          s = prevStr + s;
          prevStr = '';
        }
        if (tmpl || isexpr) {
          parts.push(s && s.replace(_bp[5], '$1'));
        } else {
          parts.push(s);
        }
      }

      function pushQBlock(_pos, _lastIndex, slash) { //eslint-disable-line
        if (slash) {
          _lastIndex = skipRegex(str, _pos);
        }

        if (tmpl && _lastIndex > _pos + 2) {
          mark = '\u2057' + qblocks.length + '~';
          qblocks.push(str.slice(_pos, _lastIndex));
          prevStr += str.slice(start, _pos) + mark;
          start = _lastIndex;
        }
        return _lastIndex
      }
    };

    _brackets.hasExpr = function hasExpr (str) {
      return _cache[4].test(str)
    };

    _brackets.loopKeys = function loopKeys (expr) {
      var m = expr.match(_cache[9]);

      return m
        ? { key: m[1], pos: m[2], val: _cache[0] + m[3].trim() + _cache[1] }
        : { val: expr.trim() }
    };

    _brackets.array = function array (pair) {
      return pair ? _create(pair) : _cache
    };

    function _reset (pair) {
      if ((pair || (pair = DEFAULT)) !== _cache[8]) {
        _cache = _create(pair);
        _regex = pair === DEFAULT ? _loopback : _rewrite;
        _cache[9] = _regex(_pairs[9]);
      }
      cachedBrackets = pair;
    }

    function _setSettings (o) {
      var b;

      o = o || {};
      b = o.brackets;
      Object.defineProperty(o, 'brackets', {
        set: _reset,
        get: function () { return cachedBrackets },
        enumerable: true
      });
      _settings = o;
      _reset(b);
    }

    Object.defineProperty(_brackets, 'settings', {
      set: _setSettings,
      get: function () { return _settings }
    });

    /* istanbul ignore next: in the browser riot is always in the scope */
    _brackets.settings = typeof riot !== 'undefined' && riot.settings || {};
    _brackets.set = _reset;
    _brackets.skipRegex = skipRegex;

    _brackets.R_STRINGS = R_STRINGS;
    _brackets.R_MLCOMMS = R_MLCOMMS;
    _brackets.S_QBLOCKS = S_QBLOCKS;
    _brackets.S_QBLOCK2 = S_QBLOCK2;

    return _brackets

  })();

  /**
   * @module tmpl
   *
   * tmpl          - Root function, returns the template value, render with data
   * tmpl.hasExpr  - Test the existence of a expression inside a string
   * tmpl.loopKeys - Get the keys for an 'each' loop (used by `_each`)
   */

  /* istanbul ignore next */
  var tmpl = (function () {

    var _cache = {};

    function _tmpl (str, data) {
      if (!str) { return str }

      return (_cache[str] || (_cache[str] = _create(str))).call(
        data, _logErr.bind({
          data: data,
          tmpl: str
        })
      )
    }

    _tmpl.hasExpr = brackets.hasExpr;

    _tmpl.loopKeys = brackets.loopKeys;

    // istanbul ignore next
    _tmpl.clearCache = function () { _cache = {}; };

    _tmpl.errorHandler = null;

    function _logErr (err, ctx) {

      err.riotData = {
        tagName: ctx && ctx.__ && ctx.__.tagName,
        _riot_id: ctx && ctx._riot_id  //eslint-disable-line camelcase
      };

      if (_tmpl.errorHandler) { _tmpl.errorHandler(err); }
      else if (
        typeof console !== 'undefined' &&
        typeof console.error === 'function'
      ) {
        console.error(err.message);
        console.log('<%s> %s', err.riotData.tagName || 'Unknown tag', this.tmpl); // eslint-disable-line
        console.log(this.data); // eslint-disable-line
      }
    }

    function _create (str) {
      var expr = _getTmpl(str);

      if (expr.slice(0, 11) !== 'try{return ') { expr = 'return ' + expr; }

      return new Function('E', expr + ';')    // eslint-disable-line no-new-func
    }

    var RE_DQUOTE = /\u2057/g;
    var RE_QBMARK = /\u2057(\d+)~/g;

    function _getTmpl (str) {
      var parts = brackets.split(str.replace(RE_DQUOTE, '"'), 1);
      var qstr = parts.qblocks;
      var expr;

      if (parts.length > 2 || parts[0]) {
        var i, j, list = [];

        for (i = j = 0; i < parts.length; ++i) {

          expr = parts[i];

          if (expr && (expr = i & 1

              ? _parseExpr(expr, 1, qstr)

              : '"' + expr
                  .replace(/\\/g, '\\\\')
                  .replace(/\r\n?|\n/g, '\\n')
                  .replace(/"/g, '\\"') +
                '"'

            )) { list[j++] = expr; }

        }

        expr = j < 2 ? list[0]
             : '[' + list.join(',') + '].join("")';

      } else {

        expr = _parseExpr(parts[1], 0, qstr);
      }

      if (qstr.length) {
        expr = expr.replace(RE_QBMARK, function (_, pos) {
          return qstr[pos]
            .replace(/\r/g, '\\r')
            .replace(/\n/g, '\\n')
        });
      }
      return expr
    }

    var RE_CSNAME = /^(?:(-?[_A-Za-z\xA0-\xFF][-\w\xA0-\xFF]*)|\u2057(\d+)~):/;
    var
      RE_BREND = {
        '(': /[()]/g,
        '[': /[[\]]/g,
        '{': /[{}]/g
      };

    function _parseExpr (expr, asText, qstr) {

      expr = expr
        .replace(/\s+/g, ' ').trim()
        .replace(/\ ?([[\({},?\.:])\ ?/g, '$1');

      if (expr) {
        var
          list = [],
          cnt = 0,
          match;

        while (expr &&
              (match = expr.match(RE_CSNAME)) &&
              !match.index
          ) {
          var
            key,
            jsb,
            re = /,|([[{(])|$/g;

          expr = RegExp.rightContext;
          key  = match[2] ? qstr[match[2]].slice(1, -1).trim().replace(/\s+/g, ' ') : match[1];

          while (jsb = (match = re.exec(expr))[1]) { skipBraces(jsb, re); }

          jsb  = expr.slice(0, match.index);
          expr = RegExp.rightContext;

          list[cnt++] = _wrapExpr(jsb, 1, key);
        }

        expr = !cnt ? _wrapExpr(expr, asText)
             : cnt > 1 ? '[' + list.join(',') + '].join(" ").trim()' : list[0];
      }
      return expr

      function skipBraces (ch, re) {
        var
          mm,
          lv = 1,
          ir = RE_BREND[ch];

        ir.lastIndex = re.lastIndex;
        while (mm = ir.exec(expr)) {
          if (mm[0] === ch) { ++lv; }
          else if (!--lv) { break }
        }
        re.lastIndex = lv ? expr.length : ir.lastIndex;
      }
    }

    // istanbul ignore next: not both
    var // eslint-disable-next-line max-len
      JS_CONTEXT = '"in this?this:' + (typeof window !== 'object' ? 'global' : 'window') + ').',
      JS_VARNAME = /[,{][\$\w]+(?=:)|(^ *|[^$\w\.{])(?!(?:typeof|true|false|null|undefined|in|instanceof|is(?:Finite|NaN)|void|NaN|new|Date|RegExp|Math)(?![$\w]))([$_A-Za-z][$\w]*)/g,
      JS_NOPROPS = /^(?=(\.[$\w]+))\1(?:[^.[(]|$)/;

    function _wrapExpr (expr, asText, key) {
      var tb;

      expr = expr.replace(JS_VARNAME, function (match, p, mvar, pos, s) {
        if (mvar) {
          pos = tb ? 0 : pos + match.length;

          if (mvar !== 'this' && mvar !== 'global' && mvar !== 'window') {
            match = p + '("' + mvar + JS_CONTEXT + mvar;
            if (pos) { tb = (s = s[pos]) === '.' || s === '(' || s === '['; }
          } else if (pos) {
            tb = !JS_NOPROPS.test(s.slice(pos));
          }
        }
        return match
      });

      if (tb) {
        expr = 'try{return ' + expr + '}catch(e){E(e,this)}';
      }

      if (key) {

        expr = (tb
            ? 'function(){' + expr + '}.call(this)' : '(' + expr + ')'
          ) + '?"' + key + '":""';

      } else if (asText) {

        expr = 'function(v){' + (tb
            ? expr.replace('return ', 'v=') : 'v=(' + expr + ')'
          ) + ';return v||v===0?v:""}.call(this)';
      }

      return expr
    }

    _tmpl.version = brackets.version = 'v3.0.8';

    return _tmpl

  })();

  /* istanbul ignore next */
  var observable = function(el) {

    /**
     * Extend the original object or create a new empty one
     * @type { Object }
     */

    el = el || {};

    /**
     * Private variables
     */
    var callbacks = {},
      slice = Array.prototype.slice;

    /**
     * Public Api
     */

    // extend the el object adding the observable methods
    Object.defineProperties(el, {
      /**
       * Listen to the given `event` ands
       * execute the `callback` each time an event is triggered.
       * @param  { String } event - event id
       * @param  { Function } fn - callback function
       * @returns { Object } el
       */
      on: {
        value: function(event, fn) {
          if (typeof fn == 'function')
            { (callbacks[event] = callbacks[event] || []).push(fn); }
          return el
        },
        enumerable: false,
        writable: false,
        configurable: false
      },

      /**
       * Removes the given `event` listeners
       * @param   { String } event - event id
       * @param   { Function } fn - callback function
       * @returns { Object } el
       */
      off: {
        value: function(event, fn) {
          if (event == '*' && !fn) { callbacks = {}; }
          else {
            if (fn) {
              var arr = callbacks[event];
              for (var i = 0, cb; cb = arr && arr[i]; ++i) {
                if (cb == fn) { arr.splice(i--, 1); }
              }
            } else { delete callbacks[event]; }
          }
          return el
        },
        enumerable: false,
        writable: false,
        configurable: false
      },

      /**
       * Listen to the given `event` and
       * execute the `callback` at most once
       * @param   { String } event - event id
       * @param   { Function } fn - callback function
       * @returns { Object } el
       */
      one: {
        value: function(event, fn) {
          function on() {
            el.off(event, on);
            fn.apply(el, arguments);
          }
          return el.on(event, on)
        },
        enumerable: false,
        writable: false,
        configurable: false
      },

      /**
       * Execute all callback functions that listen to
       * the given `event`
       * @param   { String } event - event id
       * @returns { Object } el
       */
      trigger: {
        value: function(event) {
          var arguments$1 = arguments;


          // getting the arguments
          var arglen = arguments.length - 1,
            args = new Array(arglen),
            fns,
            fn,
            i;

          for (i = 0; i < arglen; i++) {
            args[i] = arguments$1[i + 1]; // skip first argument
          }

          fns = slice.call(callbacks[event] || [], 0);

          for (i = 0; fn = fns[i]; ++i) {
            fn.apply(el, args);
          }

          if (callbacks['*'] && event != '*')
            { el.trigger.apply(el, ['*', event].concat(args)); }

          return el
        },
        enumerable: false,
        writable: false,
        configurable: false
      }
    });

    return el

  };

  /**
   * Short alias for Object.getOwnPropertyDescriptor
   */
  function getPropDescriptor (o, k) {
    return Object.getOwnPropertyDescriptor(o, k)
  }

  /**
   * Check if passed argument is undefined
   * @param   { * } value -
   * @returns { Boolean } -
   */
  function isUndefined(value) {
    return typeof value === T_UNDEF
  }

  /**
   * Check whether object's property could be overridden
   * @param   { Object }  obj - source object
   * @param   { String }  key - object property
   * @returns { Boolean } true if writable
   */
  function isWritable(obj, key) {
    var descriptor = getPropDescriptor(obj, key);
    return isUndefined(obj[key]) || descriptor && descriptor.writable
  }

  /**
   * Extend any object with other properties
   * @param   { Object } src - source object
   * @returns { Object } the resulting extended object
   *
   * var obj = { foo: 'baz' }
   * extend(obj, {bar: 'bar', foo: 'bar'})
   * console.log(obj) => {bar: 'bar', foo: 'bar'}
   *
   */
  function extend(src) {
    var obj;
    var i = 1;
    var args = arguments;
    var l = args.length;

    for (; i < l; i++) {
      if (obj = args[i]) {
        for (var key in obj) {
          // check if this property of the source object could be overridden
          if (isWritable(src, key))
            { src[key] = obj[key]; }
        }
      }
    }
    return src
  }

  /**
   * Alias for Object.create
   */
  function create(src) {
    return Object.create(src)
  }

  var settings = extend(create(brackets.settings), {
    skipAnonymousTags: true,
    // handle the auto updates on any DOM event
    autoUpdate: true
  })

  /**
   * Shorter and fast way to select multiple nodes in the DOM
   * @param   { String } selector - DOM selector
   * @param   { Object } ctx - DOM node where the targets of our search will is located
   * @returns { Object } dom nodes found
   */
  function $$(selector, ctx) {
    return [].slice.call((ctx || document).querySelectorAll(selector))
  }

  /**
   * Create a document text node
   * @returns { Object } create a text node to use as placeholder
   */
  function createDOMPlaceholder() {
    return document.createTextNode('')
  }

  /**
   * Toggle the visibility of any DOM node
   * @param   { Object }  dom - DOM node we want to hide
   * @param   { Boolean } show - do we want to show it?
   */

  function toggleVisibility(dom, show) {
    dom.style.display = show ? '' : 'none';
    dom.hidden = show ? false : true;
  }

  /**
   * Get the value of any DOM attribute on a node
   * @param   { Object } dom - DOM node we want to parse
   * @param   { String } name - name of the attribute we want to get
   * @returns { String | undefined } name of the node attribute whether it exists
   */
  function getAttribute(dom, name) {
    return dom.getAttribute(name)
  }

  /**
   * Remove any DOM attribute from a node
   * @param   { Object } dom - DOM node we want to update
   * @param   { String } name - name of the property we want to remove
   */
  function removeAttribute(dom, name) {
    dom.removeAttribute(name);
  }

  /**
   * Set the inner html of any DOM node SVGs included
   * @param { Object } container - DOM node where we'll inject new html
   * @param { String } html - html to inject
   * @param { Boolean } isSvg - svg tags should be treated a bit differently
   */
  /* istanbul ignore next */
  function setInnerHTML(container, html, isSvg) {
    // innerHTML is not supported on svg tags so we neet to treat them differently
    if (isSvg) {
      var node = container.ownerDocument.importNode(
        new DOMParser()
          .parseFromString(("<svg xmlns=\"" + SVG_NS + "\">" + html + "</svg>"), 'application/xml')
          .documentElement,
        true
      );

      container.appendChild(node);
    } else {
      container.innerHTML = html;
    }
  }

  /**
   * Minimize risk: only zero or one _space_ between attr & value
   * @param   { String }   html - html string we want to parse
   * @param   { Function } fn - callback function to apply on any attribute found
   */
  function walkAttributes(html, fn) {
    if (!html) { return }
    var m;
    while (m = RE_HTML_ATTRS.exec(html))
      { fn(m[1].toLowerCase(), m[2] || m[3] || m[4]); }
  }

  /**
   * Create a document fragment
   * @returns { Object } document fragment
   */
  function createFragment() {
    return document.createDocumentFragment()
  }

  /**
   * Insert safely a tag to fix #1962 #1649
   * @param   { HTMLElement } root - children container
   * @param   { HTMLElement } curr - node to insert
   * @param   { HTMLElement } next - node that should preceed the current node inserted
   */
  function safeInsert(root, curr, next) {
    root.insertBefore(curr, next.parentNode && next);
  }

  /**
   * Convert a style object to a string
   * @param   { Object } style - style object we need to parse
   * @returns { String } resulting css string
   * @example
   * styleObjectToString({ color: 'red', height: '10px'}) // => 'color: red; height: 10px'
   */
  function styleObjectToString(style) {
    return Object.keys(style).reduce(function (acc, prop) {
      return (acc + " " + prop + ": " + (style[prop]) + ";")
    }, '')
  }

  /**
   * Walk down recursively all the children tags starting dom node
   * @param   { Object }   dom - starting node where we will start the recursion
   * @param   { Function } fn - callback to transform the child node just found
   * @param   { Object }   context - fn can optionally return an object, which is passed to children
   */
  function walkNodes(dom, fn, context) {
    if (dom) {
      var res = fn(dom, context);
      var next;
      // stop the recursion
      if (res === false) { return }

      dom = dom.firstChild;

      while (dom) {
        next = dom.nextSibling;
        walkNodes(dom, fn, res);
        dom = next;
      }
    }
  }



  var dom = /*#__PURE__*/Object.freeze({
    $$: $$,
    $: $,
    createDOMPlaceholder: createDOMPlaceholder,
    mkEl: makeElement,
    setAttr: setAttribute,
    toggleVisibility: toggleVisibility,
    getAttr: getAttribute,
    remAttr: removeAttribute,
    setInnerHTML: setInnerHTML,
    walkAttrs: walkAttributes,
    createFrag: createFragment,
    safeInsert: safeInsert,
    styleObjectToString: styleObjectToString,
    walkNodes: walkNodes
  });

  /**
   * Check against the null and undefined values
   * @param   { * }  value -
   * @returns {Boolean} -
   */
  function isNil(value) {
    return isUndefined(value) || value === null
  }

  /**
   * Check if passed argument is empty. Different from falsy, because we dont consider 0 or false to be blank
   * @param { * } value -
   * @returns { Boolean } -
   */
  function isBlank(value) {
    return isNil(value) || value === ''
  }

  /**
   * Check if passed argument is a function
   * @param   { * } value -
   * @returns { Boolean } -
   */
  function isFunction(value) {
    return typeof value === T_FUNCTION
  }

  /**
   * Check if passed argument is an object, exclude null
   * NOTE: use isObject(x) && !isArray(x) to excludes arrays.
   * @param   { * } value -
   * @returns { Boolean } -
   */
  function isObject(value) {
    return value && typeof value === T_OBJECT // typeof null is 'object'
  }

  /**
   * Check if a DOM node is an svg tag or part of an svg
   * @param   { HTMLElement }  el - node we want to test
   * @returns {Boolean} true if it's an svg node
   */
  function isSvg(el) {
    var owner = el.ownerSVGElement;
    return !!owner || owner === null
  }

  /**
   * Check if passed argument is a kind of array
   * @param   { * } value -
   * @returns { Boolean } -
   */
  function isArray(value) {
    return Array.isArray(value) || value instanceof Array
  }

  /**
   * Check if the passed argument is a boolean attribute
   * @param   { String } value -
   * @returns { Boolean } -
   */
  function isBoolAttr(value) {
    return RE_BOOL_ATTRS.test(value)
  }

  /**
   * Check if passed argument is a string
   * @param   { * } value -
   * @returns { Boolean } -
   */
  function isString(value) {
    return typeof value === T_STRING
  }



  var check = /*#__PURE__*/Object.freeze({
    isBlank: isBlank,
    isFunction: isFunction,
    isObject: isObject,
    isSvg: isSvg,
    isWritable: isWritable,
    isArray: isArray,
    isBoolAttr: isBoolAttr,
    isNil: isNil,
    isString: isString,
    isUndefined: isUndefined
  });

  /**
   * Check whether an array contains an item
   * @param   { Array } array - target array
   * @param   { * } item - item to test
   * @returns { Boolean } -
   */
  function contains(array, item) {
    return array.indexOf(item) !== -1
  }

  /**
   * Specialized function for looping an array-like collection with `each={}`
   * @param   { Array } list - collection of items
   * @param   {Function} fn - callback function
   * @returns { Array } the array looped
   */
  function each(list, fn) {
    var len = list ? list.length : 0;
    var i = 0;
    for (; i < len; i++) { fn(list[i], i); }
    return list
  }

  /**
   * Faster String startsWith alternative
   * @param   { String } str - source string
   * @param   { String } value - test string
   * @returns { Boolean } -
   */
  function startsWith(str, value) {
    return str.slice(0, value.length) === value
  }

  /**
   * Function returning always a unique identifier
   * @returns { Number } - number from 0...n
   */
  var uid = (function uid() {
    var i = -1;
    return function () { return ++i; }
  })()

  /**
   * Helper function to set an immutable property
   * @param   { Object } el - object where the new property will be set
   * @param   { String } key - object key where the new property will be stored
   * @param   { * } value - value of the new property
   * @param   { Object } options - set the propery overriding the default options
   * @returns { Object } - the initial object
   */
  function define(el, key, value, options) {
    Object.defineProperty(el, key, extend({
      value: value,
      enumerable: false,
      writable: false,
      configurable: true
    }, options));
    return el
  }

  /**
   * Convert a string containing dashes to camel case
   * @param   { String } str - input string
   * @returns { String } my-string -> myString
   */
  function toCamel(str) {
    return str.replace(/-(\w)/g, function (_, c) { return c.toUpperCase(); })
  }

  /**
   * Warn a message via console
   * @param   {String} message - warning message
   */
  function warn(message) {
    if (console && console.warn) { console.warn(message); }
  }



  var misc = /*#__PURE__*/Object.freeze({
    contains: contains,
    each: each,
    getPropDescriptor: getPropDescriptor,
    startsWith: startsWith,
    uid: uid,
    defineProperty: define,
    objectCreate: create,
    extend: extend,
    toCamel: toCamel,
    warn: warn
  });

  /**
   * Set the property of an object for a given key. If something already
   * exists there, then it becomes an array containing both the old and new value.
   * @param { Object } obj - object on which to set the property
   * @param { String } key - property name
   * @param { Object } value - the value of the property to be set
   * @param { Boolean } ensureArray - ensure that the property remains an array
   * @param { Number } index - add the new item in a certain array position
   */
  function arrayishAdd(obj, key, value, ensureArray, index) {
    var dest = obj[key];
    var isArr = isArray(dest);
    var hasIndex = !isUndefined(index);

    if (dest && dest === value) { return }

    // if the key was never set, set it once
    if (!dest && ensureArray) { obj[key] = [value]; }
    else if (!dest) { obj[key] = value; }
    // if it was an array and not yet set
    else {
      if (isArr) {
        var oldIndex = dest.indexOf(value);
        // this item never changed its position
        if (oldIndex === index) { return }
        // remove the item from its old position
        if (oldIndex !== -1) { dest.splice(oldIndex, 1); }
        // move or add the item
        if (hasIndex) {
          dest.splice(index, 0, value);
        } else {
          dest.push(value);
        }
      } else { obj[key] = [dest, value]; }
    }
  }

  /**
   * Detect the tag implementation by a DOM node
   * @param   { Object } dom - DOM node we need to parse to get its tag implementation
   * @returns { Object } it returns an object containing the implementation of a custom tag (template and boot function)
   */
  function get(dom) {
    return dom.tagName && __TAG_IMPL[getAttribute(dom, IS_DIRECTIVE) ||
      getAttribute(dom, IS_DIRECTIVE) || dom.tagName.toLowerCase()]
  }

  /**
   * Get the tag name of any DOM node
   * @param   { Object } dom - DOM node we want to parse
   * @param   { Boolean } skipDataIs - hack to ignore the data-is attribute when attaching to parent
   * @returns { String } name to identify this dom node in riot
   */
  function getName(dom, skipDataIs) {
    var child = get(dom);
    var namedTag = !skipDataIs && getAttribute(dom, IS_DIRECTIVE);
    return namedTag && !tmpl.hasExpr(namedTag) ?
      namedTag : child ? child.name : dom.tagName.toLowerCase()
  }

  /**
   * Return a temporary context containing also the parent properties
   * @this Tag
   * @param { Tag } - temporary tag context containing all the parent properties
   */
  function inheritParentProps() {
    if (this.parent) { return extend(create(this), this.parent) }
    return this
  }

  /*
    Includes hacks needed for the Internet Explorer version 9 and below
    See: http://kangax.github.io/compat-table/es5/#ie8
         http://codeplanet.io/dropping-ie8/
  */

  var
    reHasYield  = /<yield\b/i,
    reYieldAll  = /<yield\s*(?:\/>|>([\S\s]*?)<\/yield\s*>|>)/ig,
    reYieldSrc  = /<yield\s+to=['"]([^'">]*)['"]\s*>([\S\s]*?)<\/yield\s*>/ig,
    reYieldDest = /<yield\s+from=['"]?([-\w]+)['"]?\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig,
    rootEls = { tr: 'tbody', th: 'tr', td: 'tr', col: 'colgroup' },
    tblTags = IE_VERSION && IE_VERSION < 10 ? RE_SPECIAL_TAGS : RE_SPECIAL_TAGS_NO_OPTION,
    GENERIC = 'div',
    SVG = 'svg';


  /*
    Creates the root element for table or select child elements:
    tr/th/td/thead/tfoot/tbody/caption/col/colgroup/option/optgroup
  */
  function specialTags(el, tmpl, tagName) {

    var
      select = tagName[0] === 'o',
      parent = select ? 'select>' : 'table>';

    // trim() is important here, this ensures we don't have artifacts,
    // so we can check if we have only one element inside the parent
    el.innerHTML = '<' + parent + tmpl.trim() + '</' + parent;
    parent = el.firstChild;

    // returns the immediate parent if tr/th/td/col is the only element, if not
    // returns the whole tree, as this can include additional elements
    /* istanbul ignore next */
    if (select) {
      parent.selectedIndex = -1;  // for IE9, compatible w/current riot behavior
    } else {
      // avoids insertion of cointainer inside container (ex: tbody inside tbody)
      var tname = rootEls[tagName];
      if (tname && parent.childElementCount === 1) { parent = $(tname, parent); }
    }
    return parent
  }

  /*
    Replace the yield tag from any tag template with the innerHTML of the
    original tag in the page
  */
  function replaceYield(tmpl, html) {
    // do nothing if no yield
    if (!reHasYield.test(tmpl)) { return tmpl }

    // be careful with #1343 - string on the source having `$1`
    var src = {};

    html = html && html.replace(reYieldSrc, function (_, ref, text) {
      src[ref] = src[ref] || text;   // preserve first definition
      return ''
    }).trim();

    return tmpl
      .replace(reYieldDest, function (_, ref, def) {  // yield with from - to attrs
        return src[ref] || def || ''
      })
      .replace(reYieldAll, function (_, def) {        // yield without any "from"
        return html || def || ''
      })
  }

  /**
   * Creates a DOM element to wrap the given content. Normally an `DIV`, but can be
   * also a `TABLE`, `SELECT`, `TBODY`, `TR`, or `COLGROUP` element.
   *
   * @param   { String } tmpl  - The template coming from the custom tag definition
   * @param   { String } html - HTML content that comes from the DOM element where you
   *           will mount the tag, mostly the original tag in the page
   * @param   { Boolean } isSvg - true if the root node is an svg
   * @returns { HTMLElement } DOM element with _tmpl_ merged through `YIELD` with the _html_.
   */
  function mkdom(tmpl, html, isSvg) {
    var match   = tmpl && tmpl.match(/^\s*<([-\w]+)/);
    var  tagName = match && match[1].toLowerCase();
    var el = makeElement(isSvg ? SVG : GENERIC);

    // replace all the yield tags with the tag inner html
    tmpl = replaceYield(tmpl, html);

    /* istanbul ignore next */
    if (tblTags.test(tagName))
      { el = specialTags(el, tmpl, tagName); }
    else
      { setInnerHTML(el, tmpl, isSvg); }

    return el
  }

  /**
   * Loop backward all the parents tree to detect the first custom parent tag
   * @param   { Object } tag - a Tag instance
   * @returns { Object } the instance of the first custom parent tag found
   */
  function getImmediateCustomParent(tag) {
    var ptag = tag;
    while (ptag.__.isAnonymous) {
      if (!ptag.parent) { break }
      ptag = ptag.parent;
    }
    return ptag
  }

  /**
   * Trigger DOM events
   * @param   { HTMLElement } dom - dom element target of the event
   * @param   { Function } handler - user function
   * @param   { Object } e - event object
   */
  function handleEvent(dom, handler, e) {
    var ptag = this.__.parent;
    var item = this.__.item;

    if (!item)
      { while (ptag && !item) {
        item = ptag.__.item;
        ptag = ptag.__.parent;
      } }

    // override the event properties
    /* istanbul ignore next */
    if (isWritable(e, 'currentTarget')) { e.currentTarget = dom; }
    /* istanbul ignore next */
    if (isWritable(e, 'target')) { e.target = e.srcElement; }
    /* istanbul ignore next */
    if (isWritable(e, 'which')) { e.which = e.charCode || e.keyCode; }

    e.item = item;

    handler.call(this, e);

    // avoid auto updates
    if (!settings.autoUpdate) { return }

    if (!e.preventUpdate) {
      var p = getImmediateCustomParent(this);
      // fixes #2083
      if (p.isMounted) { p.update(); }
    }
  }

  /**
   * Attach an event to a DOM node
   * @param { String } name - event name
   * @param { Function } handler - event callback
   * @param { Object } dom - dom node
   * @param { Tag } tag - tag instance
   */
  function setEventHandler(name, handler, dom, tag) {
    var eventName;
    var cb = handleEvent.bind(tag, dom, handler);

    // avoid to bind twice the same event
    // possible fix for #2332
    dom[name] = null;

    // normalize event name
    eventName = name.replace(RE_EVENTS_PREFIX, '');

    // cache the listener into the listeners array
    if (!contains(tag.__.listeners, dom)) { tag.__.listeners.push(dom); }
    if (!dom[RIOT_EVENTS_KEY]) { dom[RIOT_EVENTS_KEY] = {}; }
    if (dom[RIOT_EVENTS_KEY][name]) { dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][name]); }

    dom[RIOT_EVENTS_KEY][name] = cb;
    dom.addEventListener(eventName, cb, false);
  }

  /**
   * Create a new child tag including it correctly into its parent
   * @param   { Object } child - child tag implementation
   * @param   { Object } opts - tag options containing the DOM node where the tag will be mounted
   * @param   { String } innerHTML - inner html of the child node
   * @param   { Object } parent - instance of the parent tag including the child custom tag
   * @returns { Object } instance of the new child tag just created
   */
  function initChild(child, opts, innerHTML, parent) {
    var tag = createTag(child, opts, innerHTML);
    var tagName = opts.tagName || getName(opts.root, true);
    var ptag = getImmediateCustomParent(parent);
    // fix for the parent attribute in the looped elements
    define(tag, 'parent', ptag);
    // store the real parent tag
    // in some cases this could be different from the custom parent tag
    // for example in nested loops
    tag.__.parent = parent;

    // add this tag to the custom parent tag
    arrayishAdd(ptag.tags, tagName, tag);

    // and also to the real parent tag
    if (ptag !== parent)
      { arrayishAdd(parent.tags, tagName, tag); }

    return tag
  }

  /**
   * Removes an item from an object at a given key. If the key points to an array,
   * then the item is just removed from the array.
   * @param { Object } obj - object on which to remove the property
   * @param { String } key - property name
   * @param { Object } value - the value of the property to be removed
   * @param { Boolean } ensureArray - ensure that the property remains an array
  */
  function arrayishRemove(obj, key, value, ensureArray) {
    if (isArray(obj[key])) {
      var index = obj[key].indexOf(value);
      if (index !== -1) { obj[key].splice(index, 1); }
      if (!obj[key].length) { delete obj[key]; }
      else if (obj[key].length === 1 && !ensureArray) { obj[key] = obj[key][0]; }
    } else if (obj[key] === value)
      { delete obj[key]; } // otherwise just delete the key
  }

  /**
   * Adds the elements for a virtual tag
   * @this Tag
   * @param { Node } src - the node that will do the inserting or appending
   * @param { Tag } target - only if inserting, insert before this tag's first child
   */
  function makeVirtual(src, target) {
    var this$1 = this;

    var head = createDOMPlaceholder();
    var tail = createDOMPlaceholder();
    var frag = createFragment();
    var sib;
    var el;

    this.root.insertBefore(head, this.root.firstChild);
    this.root.appendChild(tail);

    this.__.head = el = head;
    this.__.tail = tail;

    while (el) {
      sib = el.nextSibling;
      frag.appendChild(el);
      this$1.__.virts.push(el); // hold for unmounting
      el = sib;
    }

    if (target)
      { src.insertBefore(frag, target.__.head); }
    else
      { src.appendChild(frag); }
  }

  /**
   * makes a tag virtual and replaces a reference in the dom
   * @this Tag
   * @param { tag } the tag to make virtual
   * @param { ref } the dom reference location
   */
  function makeReplaceVirtual(tag, ref) {
    var frag = createFragment();
    makeVirtual.call(tag, frag);
    ref.parentNode.replaceChild(frag, ref);
  }

  /**
   * Update dynamically created data-is tags with changing expressions
   * @param { Object } expr - expression tag and expression info
   * @param { Tag }    parent - parent for tag creation
   * @param { String } tagName - tag implementation we want to use
   */
  function updateDataIs(expr, parent, tagName) {
    var tag = expr.tag || expr.dom._tag;
    var ref;

    var ref$1 = tag ? tag.__ : {};
    var head = ref$1.head;
    var isVirtual = expr.dom.tagName === 'VIRTUAL';

    if (tag && expr.tagName === tagName) {
      tag.update();
      return
    }

    // sync _parent to accommodate changing tagnames
    if (tag) {
      // need placeholder before unmount
      if(isVirtual) {
        ref = createDOMPlaceholder();
        head.parentNode.insertBefore(ref, head);
      }

      tag.unmount(true);
    }

    // unable to get the tag name
    if (!isString(tagName)) { return }

    expr.impl = __TAG_IMPL[tagName];

    // unknown implementation
    if (!expr.impl) { return }

    expr.tag = tag = initChild(
      expr.impl, {
        root: expr.dom,
        parent: parent,
        tagName: tagName
      },
      expr.dom.innerHTML,
      parent
    );

    each(expr.attrs, function (a) { return setAttribute(tag.root, a.name, a.value); });
    expr.tagName = tagName;
    tag.mount();

    // root exist first time, after use placeholder
    if (isVirtual) { makeReplaceVirtual(tag, ref || tag.root); }

    // parent is the placeholder tag, not the dynamic tag so clean up
    parent.__.onUnmount = function () {
      var delName = tag.opts.dataIs;
      arrayishRemove(tag.parent.tags, delName, tag);
      arrayishRemove(tag.__.parent.tags, delName, tag);
      tag.unmount();
    };
  }

  /**
   * Nomalize any attribute removing the "riot-" prefix
   * @param   { String } attrName - original attribute name
   * @returns { String } valid html attribute name
   */
  function normalizeAttrName(attrName) {
    if (!attrName) { return null }
    attrName = attrName.replace(ATTRS_PREFIX, '');
    if (CASE_SENSITIVE_ATTRIBUTES[attrName]) { attrName = CASE_SENSITIVE_ATTRIBUTES[attrName]; }
    return attrName
  }

  /**
   * Update on single tag expression
   * @this Tag
   * @param { Object } expr - expression logic
   * @returns { undefined }
   */
  function updateExpression(expr) {
    if (this.root && getAttribute(this.root,'virtualized')) { return }

    var dom = expr.dom;
    // remove the riot- prefix
    var attrName = normalizeAttrName(expr.attr);
    var isToggle = contains([SHOW_DIRECTIVE, HIDE_DIRECTIVE], attrName);
    var isVirtual = expr.root && expr.root.tagName === 'VIRTUAL';
    var ref = this.__;
    var isAnonymous = ref.isAnonymous;
    var parent = dom && (expr.parent || dom.parentNode);
    // detect the style attributes
    var isStyleAttr = attrName === 'style';
    var isClassAttr = attrName === 'class';

    var value;

    // if it's a tag we could totally skip the rest
    if (expr._riot_id) {
      if (expr.__.wasCreated) {
        expr.update();
      // if it hasn't been mounted yet, do that now.
      } else {
        expr.mount();
        if (isVirtual) {
          makeReplaceVirtual(expr, expr.root);
        }
      }
      return
    }

    // if this expression has the update method it means it can handle the DOM changes by itself
    if (expr.update) { return expr.update() }

    var context = isToggle && !isAnonymous ? inheritParentProps.call(this) : this;

    // ...it seems to be a simple expression so we try to calculate its value
    value = tmpl(expr.expr, context);

    var hasValue = !isBlank(value);
    var isObj = isObject(value);

    // convert the style/class objects to strings
    if (isObj) {
      if (isClassAttr) {
        value = tmpl(JSON.stringify(value), this);
      } else if (isStyleAttr) {
        value = styleObjectToString(value);
      }
    }

    // remove original attribute
    if (expr.attr && (!expr.wasParsedOnce || !hasValue || value === false)) {
      // remove either riot-* attributes or just the attribute name
      removeAttribute(dom, getAttribute(dom, expr.attr) ? expr.attr : attrName);
    }

    // for the boolean attributes we don't need the value
    // we can convert it to checked=true to checked=checked
    if (expr.bool) { value = value ? attrName : false; }
    if (expr.isRtag) { return updateDataIs(expr, this, value) }
    if (expr.wasParsedOnce && expr.value === value) { return }

    // update the expression value
    expr.value = value;
    expr.wasParsedOnce = true;

    // if the value is an object (and it's not a style or class attribute) we can not do much more with it
    if (isObj && !isClassAttr && !isStyleAttr && !isToggle) { return }
    // avoid to render undefined/null values
    if (!hasValue) { value = ''; }

    // textarea and text nodes have no attribute name
    if (!attrName) {
      // about #815 w/o replace: the browser converts the value to a string,
      // the comparison by "==" does too, but not in the server
      value += '';
      // test for parent avoids error with invalid assignment to nodeValue
      if (parent) {
        // cache the parent node because somehow it will become null on IE
        // on the next iteration
        expr.parent = parent;
        if (parent.tagName === 'TEXTAREA') {
          parent.value = value;                    // #1113
          if (!IE_VERSION) { dom.nodeValue = value; }  // #1625 IE throws here, nodeValue
        }                                         // will be available on 'updated'
        else { dom.nodeValue = value; }
      }
      return
    }


    // event handler
    if (isFunction(value)) {
      setEventHandler(attrName, value, dom, this);
    // show / hide
    } else if (isToggle) {
      toggleVisibility(dom, attrName === HIDE_DIRECTIVE ? !value : value);
    // handle attributes
    } else {
      if (expr.bool) {
        dom[attrName] = value;
      }

      if (attrName === 'value' && dom.value !== value) {
        dom.value = value;
      } else if (hasValue && value !== false) {
        setAttribute(dom, attrName, value);
      }

      // make sure that in case of style changes
      // the element stays hidden
      if (isStyleAttr && dom.hidden) { toggleVisibility(dom, false); }
    }
  }

  /**
   * Update all the expressions in a Tag instance
   * @this Tag
   * @param { Array } expressions - expression that must be re evaluated
   */
  function update(expressions) {
    each(expressions, updateExpression.bind(this));
  }

  /**
   * We need to update opts for this tag. That requires updating the expressions
   * in any attributes on the tag, and then copying the result onto opts.
   * @this Tag
   * @param   {Boolean} isLoop - is it a loop tag?
   * @param   { Tag }  parent - parent tag node
   * @param   { Boolean }  isAnonymous - is it a tag without any impl? (a tag not registered)
   * @param   { Object }  opts - tag options
   * @param   { Array }  instAttrs - tag attributes array
   */
  function updateOpts(isLoop, parent, isAnonymous, opts, instAttrs) {
    // isAnonymous `each` tags treat `dom` and `root` differently. In this case
    // (and only this case) we don't need to do updateOpts, because the regular parse
    // will update those attrs. Plus, isAnonymous tags don't need opts anyway
    if (isLoop && isAnonymous) { return }
    var ctx = isLoop ? inheritParentProps.call(this) : parent || this;

    each(instAttrs, function (attr) {
      if (attr.expr) { updateExpression.call(ctx, attr.expr); }
      // normalize the attribute names
      opts[toCamel(attr.name).replace(ATTRS_PREFIX, '')] = attr.expr ? attr.expr.value : attr.value;
    });
  }

  /**
   * Update the tag expressions and options
   * @param { Tag } tag - tag object
   * @param { * } data - data we want to use to extend the tag properties
   * @param { Array } expressions - component expressions array
   * @returns { Tag } the current tag instance
   */
  function componentUpdate(tag, data, expressions) {
    var __ = tag.__;
    var nextOpts = {};
    var canTrigger = tag.isMounted && !__.skipAnonymous;

    // inherit properties from the parent tag
    if (__.isAnonymous && __.parent) { extend(tag, __.parent); }
    extend(tag, data);

    updateOpts.apply(tag, [__.isLoop, __.parent, __.isAnonymous, nextOpts, __.instAttrs]);

    if (
      canTrigger &&
      tag.isMounted &&
      isFunction(tag.shouldUpdate) && !tag.shouldUpdate(data, nextOpts)
    ) {
      return tag
    }

    extend(tag.opts, nextOpts);

    if (canTrigger) { tag.trigger('update', data); }
    update.call(tag, expressions);
    if (canTrigger) { tag.trigger('updated'); }

    return tag
  }

  /**
   * Get selectors for tags
   * @param   { Array } tags - tag names to select
   * @returns { String } selector
   */
  function query(tags) {
    // select all tags
    if (!tags) {
      var keys = Object.keys(__TAG_IMPL);
      return keys + query(keys)
    }

    return tags
      .filter(function (t) { return !/[^-\w]/.test(t); })
      .reduce(function (list, t) {
        var name = t.trim().toLowerCase();
        return list + ",[" + IS_DIRECTIVE + "=\"" + name + "\"]"
      }, '')
  }

  /**
   * Another way to create a riot tag a bit more es6 friendly
   * @param { HTMLElement } el - tag DOM selector or DOM node/s
   * @param { Object } opts - tag logic
   * @returns { Tag } new riot tag instance
   */
  function Tag(el, opts) {
    // get the tag properties from the class constructor
    var ref = this;
    var name = ref.name;
    var tmpl = ref.tmpl;
    var css = ref.css;
    var attrs = ref.attrs;
    var onCreate = ref.onCreate;
    // register a new tag and cache the class prototype
    if (!__TAG_IMPL[name]) {
      tag(name, tmpl, css, attrs, onCreate);
      // cache the class constructor
      __TAG_IMPL[name].class = this.constructor;
    }

    // mount the tag using the class instance
    mount$1(el, name, opts, this);
    // inject the component css
    if (css) { styleManager.inject(); }

    return this
  }

  /**
   * Create a new riot tag implementation
   * @param   { String }   name - name/id of the new riot tag
   * @param   { String }   tmpl - tag template
   * @param   { String }   css - custom tag css
   * @param   { String }   attrs - root tag attributes
   * @param   { Function } fn - user function
   * @returns { String } name/id of the tag just created
   */
  function tag(name, tmpl, css, attrs, fn) {
    if (isFunction(attrs)) {
      fn = attrs;

      if (/^[\w-]+\s?=/.test(css)) {
        attrs = css;
        css = '';
      } else
        { attrs = ''; }
    }

    if (css) {
      if (isFunction(css))
        { fn = css; }
      else
        { styleManager.add(css); }
    }

    name = name.toLowerCase();
    __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };

    return name
  }

  /**
   * Create a new riot tag implementation (for use by the compiler)
   * @param   { String }   name - name/id of the new riot tag
   * @param   { String }   tmpl - tag template
   * @param   { String }   css - custom tag css
   * @param   { String }   attrs - root tag attributes
   * @param   { Function } fn - user function
   * @returns { String } name/id of the tag just created
   */
  function tag2(name, tmpl, css, attrs, fn) {
    if (css) { styleManager.add(css, name); }

    __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };

    return name
  }

  /**
   * Mount a tag using a specific tag implementation
   * @param   { * } selector - tag DOM selector or DOM node/s
   * @param   { String } tagName - tag implementation name
   * @param   { Object } opts - tag logic
   * @returns { Array } new tags instances
   */
  function mount(selector, tagName, opts) {
    var tags = [];
    var elem, allTags;

    function pushTagsTo(root) {
      if (root.tagName) {
        var riotTag = getAttribute(root, IS_DIRECTIVE), tag;

        // have tagName? force riot-tag to be the same
        if (tagName && riotTag !== tagName) {
          riotTag = tagName;
          setAttribute(root, IS_DIRECTIVE, tagName);
        }

        tag = mount$1(root, riotTag || root.tagName.toLowerCase(), opts);

        if (tag)
          { tags.push(tag); }
      } else if (root.length)
        { each(root, pushTagsTo); } // assume nodeList
    }

    // inject styles into DOM
    styleManager.inject();

    if (isObject(tagName)) {
      opts = tagName;
      tagName = 0;
    }

    // crawl the DOM to find the tag
    if (isString(selector)) {
      selector = selector === '*' ?
        // select all registered tags
        // & tags found with the riot-tag attribute set
        allTags = query() :
        // or just the ones named like the selector
        selector + query(selector.split(/, */));

      // make sure to pass always a selector
      // to the querySelectorAll function
      elem = selector ? $$(selector) : [];
    }
    else
      // probably you have passed already a tag or a NodeList
      { elem = selector; }

    // select all the registered and mount them inside their root elements
    if (tagName === '*') {
      // get all custom tags
      tagName = allTags || query();
      // if the root els it's just a single tag
      if (elem.tagName)
        { elem = $$(tagName, elem); }
      else {
        // select all the children for all the different root elements
        var nodeList = [];

        each(elem, function (_el) { return nodeList.push($$(tagName, _el)); });

        elem = nodeList;
      }
      // get rid of the tagName
      tagName = 0;
    }

    pushTagsTo(elem);

    return tags
  }

  // Create a mixin that could be globally shared across all the tags
  var mixins = {};
  var globals = mixins[GLOBAL_MIXIN] = {};
  var mixins_id = 0;

  /**
   * Create/Return a mixin by its name
   * @param   { String }  name - mixin name (global mixin if object)
   * @param   { Object }  mix - mixin logic
   * @param   { Boolean } g - is global?
   * @returns { Object }  the mixin logic
   */
  function mixin(name, mix, g) {
    // Unnamed global
    if (isObject(name)) {
      mixin(("__" + (mixins_id++) + "__"), name, true);
      return
    }

    var store = g ? globals : mixins;

    // Getter
    if (!mix) {
      if (isUndefined(store[name]))
        { throw new Error(("Unregistered mixin: " + name)) }

      return store[name]
    }

    // Setter
    store[name] = isFunction(mix) ?
      extend(mix.prototype, store[name] || {}) && mix :
      extend(store[name] || {}, mix);
  }

  /**
   * Update all the tags instances created
   * @returns { Array } all the tags instances
   */
  function update$1() {
    return each(__TAGS_CACHE, function (tag) { return tag.update(); })
  }

  function unregister(name) {
    __TAG_IMPL[name] = null;
  }

  var version = 'v3.9.1';

  var core = /*#__PURE__*/Object.freeze({
    Tag: Tag,
    tag: tag,
    tag2: tag2,
    mount: mount,
    mixin: mixin,
    update: update$1,
    unregister: unregister,
    version: version
  });

  /**
   * Add a mixin to this tag
   * @returns { Tag } the current tag instance
   */
  function componentMixin(tag$$1) {
    var mixins = [], len = arguments.length - 1;
    while ( len-- > 0 ) mixins[ len ] = arguments[ len + 1 ];

    each(mixins, function (mix) {
      var instance;
      var obj;
      var props = [];

      // properties blacklisted and will not be bound to the tag instance
      var propsBlacklist = ['init', '__proto__'];

      mix = isString(mix) ? mixin(mix) : mix;

      // check if the mixin is a function
      if (isFunction(mix)) {
        // create the new mixin instance
        instance = new mix();
      } else { instance = mix; }

      var proto = Object.getPrototypeOf(instance);

      // build multilevel prototype inheritance chain property list
      do { props = props.concat(Object.getOwnPropertyNames(obj || instance)); }
      while (obj = Object.getPrototypeOf(obj || instance))

      // loop the keys in the function prototype or the all object keys
      each(props, function (key) {
        // bind methods to tag
        // allow mixins to override other properties/parent mixins
        if (!contains(propsBlacklist, key)) {
          // check for getters/setters
          var descriptor = getPropDescriptor(instance, key) || getPropDescriptor(proto, key);
          var hasGetterSetter = descriptor && (descriptor.get || descriptor.set);

          // apply method only if it does not already exist on the instance
          if (!tag$$1.hasOwnProperty(key) && hasGetterSetter) {
            Object.defineProperty(tag$$1, key, descriptor);
          } else {
            tag$$1[key] = isFunction(instance[key]) ?
              instance[key].bind(tag$$1) :
              instance[key];
          }
        }
      });

      // init method will be called automatically
      if (instance.init)
        { instance.init.bind(tag$$1)(tag$$1.opts); }
    });

    return tag$$1
  }

  /**
   * Move the position of a custom tag in its parent tag
   * @this Tag
   * @param   { String } tagName - key where the tag was stored
   * @param   { Number } newPos - index where the new tag will be stored
   */
  function moveChild(tagName, newPos) {
    var parent = this.parent;
    var tags;
    // no parent no move
    if (!parent) { return }

    tags = parent.tags[tagName];

    if (isArray(tags))
      { tags.splice(newPos, 0, tags.splice(tags.indexOf(this), 1)[0]); }
    else { arrayishAdd(parent.tags, tagName, this); }
  }

  /**
   * Move virtual tag and all child nodes
   * @this Tag
   * @param { Node } src  - the node that will do the inserting
   * @param { Tag } target - insert before this tag's first child
   */
  function moveVirtual(src, target) {
    var this$1 = this;

    var el = this.__.head;
    var sib;
    var frag = createFragment();

    while (el) {
      sib = el.nextSibling;
      frag.appendChild(el);
      el = sib;
      if (el === this$1.__.tail) {
        frag.appendChild(el);
        src.insertBefore(frag, target.__.head);
        break
      }
    }
  }

  /**
   * Convert the item looped into an object used to extend the child tag properties
   * @param   { Object } expr - object containing the keys used to extend the children tags
   * @param   { * } key - value to assign to the new object returned
   * @param   { * } val - value containing the position of the item in the array
   * @param   { Object } base - prototype object for the new item
   * @returns { Object } - new object containing the values of the original item
   *
   * The variables 'key' and 'val' are arbitrary.
   * They depend on the collection type looped (Array, Object)
   * and on the expression used on the each tag
   *
   */
  function mkitem(expr, key, val, base) {
    var item = base ? create(base) : {};
    item[expr.key] = key;
    if (expr.pos) { item[expr.pos] = val; }
    return item
  }

  /**
   * Unmount the redundant tags
   * @param   { Array } items - array containing the current items to loop
   * @param   { Array } tags - array containing all the children tags
   */
  function unmountRedundant(items, tags) {
    var i = tags.length;
    var j = items.length;

    while (i > j) {
      i--;
      remove.apply(tags[i], [tags, i]);
    }
  }


  /**
   * Remove a child tag
   * @this Tag
   * @param   { Array } tags - tags collection
   * @param   { Number } i - index of the tag to remove
   */
  function remove(tags, i) {
    tags.splice(i, 1);
    this.unmount();
    arrayishRemove(this.parent, this, this.__.tagName, true);
  }

  /**
   * Move the nested custom tags in non custom loop tags
   * @this Tag
   * @param   { Number } i - current position of the loop tag
   */
  function moveNestedTags(i) {
    var this$1 = this;

    each(Object.keys(this.tags), function (tagName) {
      moveChild.apply(this$1.tags[tagName], [tagName, i]);
    });
  }

  /**
   * Move a child tag
   * @this Tag
   * @param   { HTMLElement } root - dom node containing all the loop children
   * @param   { Tag } nextTag - instance of the next tag preceding the one we want to move
   * @param   { Boolean } isVirtual - is it a virtual tag?
   */
  function move(root, nextTag, isVirtual) {
    if (isVirtual)
      { moveVirtual.apply(this, [root, nextTag]); }
    else
      { safeInsert(root, this.root, nextTag.root); }
  }

  /**
   * Insert and mount a child tag
   * @this Tag
   * @param   { HTMLElement } root - dom node containing all the loop children
   * @param   { Tag } nextTag - instance of the next tag preceding the one we want to insert
   * @param   { Boolean } isVirtual - is it a virtual tag?
   */
  function insert(root, nextTag, isVirtual) {
    if (isVirtual)
      { makeVirtual.apply(this, [root, nextTag]); }
    else
      { safeInsert(root, this.root, nextTag.root); }
  }

  /**
   * Append a new tag into the DOM
   * @this Tag
   * @param   { HTMLElement } root - dom node containing all the loop children
   * @param   { Boolean } isVirtual - is it a virtual tag?
   */
  function append(root, isVirtual) {
    if (isVirtual)
      { makeVirtual.call(this, root); }
    else
      { root.appendChild(this.root); }
  }

  /**
   * Return the value we want to use to lookup the postion of our items in the collection
   * @param   { String }  keyAttr         - lookup string or expression
   * @param   { * }       originalItem    - original item from the collection
   * @param   { Object }  keyedItem       - object created by riot via { item, i in collection }
   * @param   { Boolean } hasKeyAttrExpr  - flag to check whether the key is an expression
   * @returns { * } value that we will use to figure out the item position via collection.indexOf
   */
  function getItemId(keyAttr, originalItem, keyedItem, hasKeyAttrExpr) {
    if (keyAttr) {
      return hasKeyAttrExpr ?  tmpl(keyAttr, keyedItem) :  originalItem[keyAttr]
    }

    return originalItem
  }

  /**
   * Manage tags having the 'each'
   * @param   { HTMLElement } dom - DOM node we need to loop
   * @param   { Tag } parent - parent tag instance where the dom node is contained
   * @param   { String } expr - string contained in the 'each' attribute
   * @returns { Object } expression object for this each loop
   */
  function _each(dom, parent, expr) {
    var mustReorder = typeof getAttribute(dom, LOOP_NO_REORDER_DIRECTIVE) !== T_STRING || removeAttribute(dom, LOOP_NO_REORDER_DIRECTIVE);
    var keyAttr = getAttribute(dom, KEY_DIRECTIVE);
    var hasKeyAttrExpr = keyAttr ? tmpl.hasExpr(keyAttr) : false;
    var tagName = getName(dom);
    var impl = __TAG_IMPL[tagName];
    var parentNode = dom.parentNode;
    var placeholder = createDOMPlaceholder();
    var child = get(dom);
    var ifExpr = getAttribute(dom, CONDITIONAL_DIRECTIVE);
    var tags = [];
    var isLoop = true;
    var innerHTML = dom.innerHTML;
    var isAnonymous = !__TAG_IMPL[tagName];
    var isVirtual = dom.tagName === 'VIRTUAL';
    var oldItems = [];
    var hasKeys;

    // remove the each property from the original tag
    removeAttribute(dom, LOOP_DIRECTIVE);
    removeAttribute(dom, KEY_DIRECTIVE);

    // parse the each expression
    expr = tmpl.loopKeys(expr);
    expr.isLoop = true;

    if (ifExpr) { removeAttribute(dom, CONDITIONAL_DIRECTIVE); }

    // insert a marked where the loop tags will be injected
    parentNode.insertBefore(placeholder, dom);
    parentNode.removeChild(dom);

    expr.update = function updateEach() {
      // get the new items collection
      expr.value = tmpl(expr.val, parent);

      var items = expr.value;
      var frag = createFragment();
      var isObject = !isArray(items) && !isString(items);
      var root = placeholder.parentNode;
      var tmpItems = [];

      // if this DOM was removed the update here is useless
      // this condition fixes also a weird async issue on IE in our unit test
      if (!root) { return }

      // object loop. any changes cause full redraw
      if (isObject) {
        hasKeys = items || false;
        items = hasKeys ?
          Object.keys(items).map(function (key) { return mkitem(expr, items[key], key); }) : [];
      } else {
        hasKeys = false;
      }

      if (ifExpr) {
        items = items.filter(function (item, i) {
          if (expr.key && !isObject)
            { return !!tmpl(ifExpr, mkitem(expr, item, i, parent)) }

          return !!tmpl(ifExpr, extend(create(parent), item))
        });
      }

      // loop all the new items
      each(items, function (_item, i) {
        var item = !hasKeys && expr.key ? mkitem(expr, _item, i) : _item;
        var itemId = getItemId(keyAttr, _item, item, hasKeyAttrExpr);
        // reorder only if the items are objects
        var doReorder = mustReorder && typeof _item === T_OBJECT && !hasKeys;
        var oldPos = oldItems.indexOf(itemId);
        var isNew = oldPos === -1;
        var pos = !isNew && doReorder ? oldPos : i;
        // does a tag exist in this position?
        var tag = tags[pos];
        var mustAppend = i >= oldItems.length;
        var mustCreate =  doReorder && isNew || !doReorder && !tag;

        // new tag
        if (mustCreate) {
          tag = createTag(impl, {
            parent: parent,
            isLoop: isLoop,
            isAnonymous: isAnonymous,
            tagName: tagName,
            root: dom.cloneNode(isAnonymous),
            item: item,
            index: i,
          }, innerHTML);

          // mount the tag
          tag.mount();

          if (mustAppend)
            { append.apply(tag, [frag || root, isVirtual]); }
          else
            { insert.apply(tag, [root, tags[i], isVirtual]); }

          if (!mustAppend) { oldItems.splice(i, 0, item); }
          tags.splice(i, 0, tag);
          if (child) { arrayishAdd(parent.tags, tagName, tag, true); }
        } else if (pos !== i && doReorder) {
          // move
          if (keyAttr || contains(items, oldItems[pos])) {
            move.apply(tag, [root, tags[i], isVirtual]);
            // move the old tag instance
            tags.splice(i, 0, tags.splice(pos, 1)[0]);
            // move the old item
            oldItems.splice(i, 0, oldItems.splice(pos, 1)[0]);
          }

          // update the position attribute if it exists
          if (expr.pos) { tag[expr.pos] = i; }

          // if the loop tags are not custom
          // we need to move all their custom tags into the right position
          if (!child && tag.tags) { moveNestedTags.call(tag, i); }
        }

        // cache the original item to use it in the events bound to this node
        // and its children
        extend(tag.__, {
          item: item,
          index: i,
          parent: parent
        });

        tmpItems[i] = itemId;

        if (!mustCreate) { tag.update(item); }
      });

      // remove the redundant tags
      unmountRedundant(items, tags);

      // clone the items array
      oldItems = tmpItems.slice();

      root.insertBefore(frag, placeholder);
    };

    expr.unmount = function () {
      each(tags, function (t) { t.unmount(); });
    };

    return expr
  }

  var RefExpr = {
    init: function init(dom, parent, attrName, attrValue) {
      this.dom = dom;
      this.attr = attrName;
      this.rawValue = attrValue;
      this.parent = parent;
      this.hasExp = tmpl.hasExpr(attrValue);
      return this
    },
    update: function update() {
      var old = this.value;
      var customParent = this.parent && getImmediateCustomParent(this.parent);
      // if the referenced element is a custom tag, then we set the tag itself, rather than DOM
      var tagOrDom = this.dom.__ref || this.tag || this.dom;

      this.value = this.hasExp ? tmpl(this.rawValue, this.parent) : this.rawValue;

      // the name changed, so we need to remove it from the old key (if present)
      if (!isBlank(old) && customParent) { arrayishRemove(customParent.refs, old, tagOrDom); }
      if (!isBlank(this.value) && isString(this.value)) {
        // add it to the refs of parent tag (this behavior was changed >=3.0)
        if (customParent) { arrayishAdd(
          customParent.refs,
          this.value,
          tagOrDom,
          // use an array if it's a looped node and the ref is not an expression
          null,
          this.parent.__.index
        ); }

        if (this.value !== old) {
          setAttribute(this.dom, this.attr, this.value);
        }
      } else {
        removeAttribute(this.dom, this.attr);
      }

      // cache the ref bound to this dom node
      // to reuse it in future (see also #2329)
      if (!this.dom.__ref) { this.dom.__ref = tagOrDom; }
    },
    unmount: function unmount() {
      var tagOrDom = this.tag || this.dom;
      var customParent = this.parent && getImmediateCustomParent(this.parent);
      if (!isBlank(this.value) && customParent)
        { arrayishRemove(customParent.refs, this.value, tagOrDom); }
    }
  }

  /**
   * Create a new ref directive
   * @param   { HTMLElement } dom - dom node having the ref attribute
   * @param   { Tag } context - tag instance where the DOM node is located
   * @param   { String } attrName - either 'ref' or 'data-ref'
   * @param   { String } attrValue - value of the ref attribute
   * @returns { RefExpr } a new RefExpr object
   */
  function createRefDirective(dom, tag, attrName, attrValue) {
    return create(RefExpr).init(dom, tag, attrName, attrValue)
  }

  /**
   * Trigger the unmount method on all the expressions
   * @param   { Array } expressions - DOM expressions
   */
  function unmountAll(expressions) {
    each(expressions, function (expr) {
      if (expr.unmount) { expr.unmount(true); }
      else if (expr.tagName) { expr.tag.unmount(true); }
      else if (expr.unmount) { expr.unmount(); }
    });
  }

  var IfExpr = {
    init: function init(dom, tag, expr) {
      removeAttribute(dom, CONDITIONAL_DIRECTIVE);
      extend(this, { tag: tag, expr: expr, stub: createDOMPlaceholder(), pristine: dom });
      var p = dom.parentNode;
      p.insertBefore(this.stub, dom);
      p.removeChild(dom);

      return this
    },
    update: function update$$1() {
      this.value = tmpl(this.expr, this.tag);

      if (this.value && !this.current) { // insert
        this.current = this.pristine.cloneNode(true);
        this.stub.parentNode.insertBefore(this.current, this.stub);
        this.expressions = parseExpressions.apply(this.tag, [this.current, true]);
      } else if (!this.value && this.current) { // remove
        unmountAll(this.expressions);
        if (this.current._tag) {
          this.current._tag.unmount();
        } else if (this.current.parentNode) {
          this.current.parentNode.removeChild(this.current);
        }
        this.current = null;
        this.expressions = [];
      }

      if (this.value) { update.call(this.tag, this.expressions); }
    },
    unmount: function unmount() {
      unmountAll(this.expressions || []);
    }
  }

  /**
   * Create a new if directive
   * @param   { HTMLElement } dom - if root dom node
   * @param   { Tag } context - tag instance where the DOM node is located
   * @param   { String } attr - if expression
   * @returns { IFExpr } a new IfExpr object
   */
  function createIfDirective(dom, tag, attr) {
    return create(IfExpr).init(dom, tag, attr)
  }

  /**
   * Walk the tag DOM to detect the expressions to evaluate
   * @this Tag
   * @param   { HTMLElement } root - root tag where we will start digging the expressions
   * @param   { Boolean } mustIncludeRoot - flag to decide whether the root must be parsed as well
   * @returns { Array } all the expressions found
   */
  function parseExpressions(root, mustIncludeRoot) {
    var this$1 = this;

    var expressions = [];

    walkNodes(root, function (dom) {
      var type = dom.nodeType;
      var attr;
      var tagImpl;

      if (!mustIncludeRoot && dom === root) { return }

      // text node
      if (type === 3 && dom.parentNode.tagName !== 'STYLE' && tmpl.hasExpr(dom.nodeValue))
        { expressions.push({dom: dom, expr: dom.nodeValue}); }

      if (type !== 1) { return }

      var isVirtual = dom.tagName === 'VIRTUAL';

      // loop. each does it's own thing (for now)
      if (attr = getAttribute(dom, LOOP_DIRECTIVE)) {
        if(isVirtual) { setAttribute(dom, 'loopVirtual', true); } // ignore here, handled in _each
        expressions.push(_each(dom, this$1, attr));
        return false
      }

      // if-attrs become the new parent. Any following expressions (either on the current
      // element, or below it) become children of this expression.
      if (attr = getAttribute(dom, CONDITIONAL_DIRECTIVE)) {
        expressions.push(createIfDirective(dom, this$1, attr));
        return false
      }

      if (attr = getAttribute(dom, IS_DIRECTIVE)) {
        if (tmpl.hasExpr(attr)) {
          expressions.push({
            isRtag: true,
            expr: attr,
            dom: dom,
            attrs: [].slice.call(dom.attributes)
          });

          return false
        }
      }

      // if this is a tag, stop traversing here.
      // we ignore the root, since parseExpressions is called while we're mounting that root
      tagImpl = get(dom);

      if(isVirtual) {
        if(getAttribute(dom, 'virtualized')) {dom.parentElement.removeChild(dom); } // tag created, remove from dom
        if(!tagImpl && !getAttribute(dom, 'virtualized') && !getAttribute(dom, 'loopVirtual'))  // ok to create virtual tag
          { tagImpl = { tmpl: dom.outerHTML }; }
      }

      if (tagImpl && (dom !== root || mustIncludeRoot)) {
        var hasIsDirective = getAttribute(dom, IS_DIRECTIVE);
        if(isVirtual && !hasIsDirective) { // handled in update
          // can not remove attribute like directives
          // so flag for removal after creation to prevent maximum stack error
          setAttribute(dom, 'virtualized', true);
          var tag = createTag(
            {tmpl: dom.outerHTML},
            {root: dom, parent: this$1},
            dom.innerHTML
          );

          expressions.push(tag); // no return, anonymous tag, keep parsing
        } else {
          if (hasIsDirective && isVirtual)
            { warn(("Virtual tags shouldn't be used together with the \"" + IS_DIRECTIVE + "\" attribute - https://github.com/riot/riot/issues/2511")); }

          expressions.push(
            initChild(
              tagImpl,
              {
                root: dom,
                parent: this$1
              },
              dom.innerHTML,
              this$1
            )
          );
          return false
        }
      }

      // attribute expressions
      parseAttributes.apply(this$1, [dom, dom.attributes, function (attr, expr) {
        if (!expr) { return }
        expressions.push(expr);
      }]);
    });

    return expressions
  }

  /**
   * Calls `fn` for every attribute on an element. If that attr has an expression,
   * it is also passed to fn.
   * @this Tag
   * @param   { HTMLElement } dom - dom node to parse
   * @param   { Array } attrs - array of attributes
   * @param   { Function } fn - callback to exec on any iteration
   */
  function parseAttributes(dom, attrs, fn) {
    var this$1 = this;

    each(attrs, function (attr) {
      if (!attr) { return false }

      var name = attr.name;
      var bool = isBoolAttr(name);
      var expr;

      if (contains(REF_DIRECTIVES, name) && dom.tagName.toLowerCase() !== YIELD_TAG) {
        expr =  createRefDirective(dom, this$1, name, attr.value);
      } else if (tmpl.hasExpr(attr.value)) {
        expr = {dom: dom, expr: attr.value, attr: name, bool: bool};
      }

      fn(attr, expr);
    });
  }

  /**
   * Manage the mount state of a tag triggering also the observable events
   * @this Tag
   * @param { Boolean } value - ..of the isMounted flag
   */
  function setMountState(value) {
    var ref = this.__;
    var isAnonymous = ref.isAnonymous;

    define(this, 'isMounted', value);

    if (!isAnonymous) {
      if (value) { this.trigger('mount'); }
      else {
        this.trigger('unmount');
        this.off('*');
        this.__.wasCreated = false;
      }
    }
  }

  /**
   * Mount the current tag instance
   * @returns { Tag } the current tag instance
   */
  function componentMount(tag$$1, dom, expressions, opts) {
    var __ = tag$$1.__;
    var root = __.root;
    root._tag = tag$$1; // keep a reference to the tag just created

    // Read all the attrs on this instance. This give us the info we need for updateOpts
    parseAttributes.apply(__.parent, [root, root.attributes, function (attr, expr) {
      if (!__.isAnonymous && RefExpr.isPrototypeOf(expr)) { expr.tag = tag$$1; }
      attr.expr = expr;
      __.instAttrs.push(attr);
    }]);

    // update the root adding custom attributes coming from the compiler
    walkAttributes(__.impl.attrs, function (k, v) { __.implAttrs.push({name: k, value: v}); });
    parseAttributes.apply(tag$$1, [root, __.implAttrs, function (attr, expr) {
      if (expr) { expressions.push(expr); }
      else { setAttribute(root, attr.name, attr.value); }
    }]);

    // initialiation
    updateOpts.apply(tag$$1, [__.isLoop, __.parent, __.isAnonymous, opts, __.instAttrs]);

    // add global mixins
    var globalMixin = mixin(GLOBAL_MIXIN);

    if (globalMixin && !__.skipAnonymous) {
      for (var i in globalMixin) {
        if (globalMixin.hasOwnProperty(i)) {
          tag$$1.mixin(globalMixin[i]);
        }
      }
    }

    if (__.impl.fn) { __.impl.fn.call(tag$$1, opts); }

    if (!__.skipAnonymous) { tag$$1.trigger('before-mount'); }

    // parse layout after init. fn may calculate args for nested custom tags
    each(parseExpressions.apply(tag$$1, [dom, __.isAnonymous]), function (e) { return expressions.push(e); });

    tag$$1.update(__.item);

    if (!__.isAnonymous && !__.isInline) {
      while (dom.firstChild) { root.appendChild(dom.firstChild); }
    }

    define(tag$$1, 'root', root);

    // if we need to wait that the parent "mount" or "updated" event gets triggered
    if (!__.skipAnonymous && tag$$1.parent) {
      var p = getImmediateCustomParent(tag$$1.parent);
      p.one(!p.isMounted ? 'mount' : 'updated', function () {
        setMountState.call(tag$$1, true);
      });
    } else {
      // otherwise it's not a child tag we can trigger its mount event
      setMountState.call(tag$$1, true);
    }

    tag$$1.__.wasCreated = true;

    return tag$$1
  }

  /**
   * Unmount the tag instance
   * @param { Boolean } mustKeepRoot - if it's true the root node will not be removed
   * @returns { Tag } the current tag instance
   */
  function tagUnmount(tag, mustKeepRoot, expressions) {
    var __ = tag.__;
    var root = __.root;
    var tagIndex = __TAGS_CACHE.indexOf(tag);
    var p = root.parentNode;

    if (!__.skipAnonymous) { tag.trigger('before-unmount'); }

    // clear all attributes coming from the mounted tag
    walkAttributes(__.impl.attrs, function (name) {
      if (startsWith(name, ATTRS_PREFIX))
        { name = name.slice(ATTRS_PREFIX.length); }

      removeAttribute(root, name);
    });

    // remove all the event listeners
    tag.__.listeners.forEach(function (dom) {
      Object.keys(dom[RIOT_EVENTS_KEY]).forEach(function (eventName) {
        dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][eventName]);
      });
    });

    // remove tag instance from the global tags cache collection
    if (tagIndex !== -1) { __TAGS_CACHE.splice(tagIndex, 1); }

    // clean up the parent tags object
    if (__.parent && !__.isAnonymous) {
      var ptag = getImmediateCustomParent(__.parent);

      if (__.isVirtual) {
        Object
          .keys(tag.tags)
          .forEach(function (tagName) { return arrayishRemove(ptag.tags, tagName, tag.tags[tagName]); });
      } else {
        arrayishRemove(ptag.tags, __.tagName, tag);
      }
    }

    // unmount all the virtual directives
    if (tag.__.virts) {
      each(tag.__.virts, function (v) {
        if (v.parentNode) { v.parentNode.removeChild(v); }
      });
    }

    // allow expressions to unmount themselves
    unmountAll(expressions);
    each(__.instAttrs, function (a) { return a.expr && a.expr.unmount && a.expr.unmount(); });

    // clear the tag html if it's necessary
    if (mustKeepRoot) { setInnerHTML(root, ''); }
    // otherwise detach the root tag from the DOM
    else if (p) { p.removeChild(root); }

    // custom internal unmount function to avoid relying on the observable
    if (__.onUnmount) { __.onUnmount(); }

    // weird fix for a weird edge case #2409 and #2436
    // some users might use your software not as you've expected
    // so I need to add these dirty hacks to mitigate unexpected issues
    if (!tag.isMounted) { setMountState.call(tag, true); }

    setMountState.call(tag, false);

    delete root._tag;

    return tag
  }

  /**
   * Tag creation factory function
   * @constructor
   * @param { Object } impl - it contains the tag template, and logic
   * @param { Object } conf - tag options
   * @param { String } innerHTML - html that eventually we need to inject in the tag
   */
  function createTag(impl, conf, innerHTML) {
    if ( impl === void 0 ) impl = {};
    if ( conf === void 0 ) conf = {};

    var tag = conf.context || {};
    var opts = extend({}, conf.opts);
    var parent = conf.parent;
    var isLoop = conf.isLoop;
    var isAnonymous = !!conf.isAnonymous;
    var skipAnonymous = settings.skipAnonymousTags && isAnonymous;
    var item = conf.item;
    // available only for the looped nodes
    var index = conf.index;
    // All attributes on the Tag when it's first parsed
    var instAttrs = [];
    // expressions on this type of Tag
    var implAttrs = [];
    var expressions = [];
    var root = conf.root;
    var tagName = conf.tagName || getName(root);
    var isVirtual = tagName === 'virtual';
    var isInline = !isVirtual && !impl.tmpl;
    var dom;

    // make this tag observable
    if (!skipAnonymous) { observable(tag); }
    // only call unmount if we have a valid __TAG_IMPL (has name property)
    if (impl.name && root._tag) { root._tag.unmount(true); }

    // not yet mounted
    define(tag, 'isMounted', false);

    define(tag, '__', {
      impl: impl,
      root: root,
      skipAnonymous: skipAnonymous,
      implAttrs: implAttrs,
      isAnonymous: isAnonymous,
      instAttrs: instAttrs,
      innerHTML: innerHTML,
      tagName: tagName,
      index: index,
      isLoop: isLoop,
      isInline: isInline,
      item: item,
      parent: parent,
      // tags having event listeners
      // it would be better to use weak maps here but we can not introduce breaking changes now
      listeners: [],
      // these vars will be needed only for the virtual tags
      virts: [],
      wasCreated: false,
      tail: null,
      head: null
    });

    // create a unique id to this tag
    // it could be handy to use it also to improve the virtual dom rendering speed
    define(tag, '_riot_id', uid()); // base 1 allows test !t._riot_id
    define(tag, 'root', root);
    extend(tag, { opts: opts }, item);
    // protect the "tags" and "refs" property from being overridden
    define(tag, 'parent', parent || null);
    define(tag, 'tags', {});
    define(tag, 'refs', {});

    if (isInline || isLoop && isAnonymous) {
      dom = root;
    } else {
      if (!isVirtual) { root.innerHTML = ''; }
      dom = mkdom(impl.tmpl, innerHTML, isSvg(root));
    }

    define(tag, 'update', function (data) { return componentUpdate(tag, data, expressions); });
    define(tag, 'mixin', function () {
      var mixins = [], len = arguments.length;
      while ( len-- ) mixins[ len ] = arguments[ len ];

      return componentMixin.apply(void 0, [ tag ].concat( mixins ));
    });
    define(tag, 'mount', function () { return componentMount(tag, dom, expressions, opts); });
    define(tag, 'unmount', function (mustKeepRoot) { return tagUnmount(tag, mustKeepRoot, expressions); });

    return tag
  }

  /**
   * Mount a tag creating new Tag instance
   * @param   { Object } root - dom node where the tag will be mounted
   * @param   { String } tagName - name of the riot tag we want to mount
   * @param   { Object } opts - options to pass to the Tag instance
   * @param   { Object } ctx - optional context that will be used to extend an existing class ( used in riot.Tag )
   * @returns { Tag } a new Tag instance
   */
  function mount$1(root, tagName, opts, ctx) {
    var impl = __TAG_IMPL[tagName];
    var implClass = __TAG_IMPL[tagName].class;
    var context = ctx || (implClass ? create(implClass.prototype) : {});
    // cache the inner HTML to fix #855
    var innerHTML = root._innerHTML = root._innerHTML || root.innerHTML;
    var conf = extend({ root: root, opts: opts, context: context }, { parent: opts ? opts.parent : null });
    var tag;

    if (impl && root) { tag = createTag(impl, conf, innerHTML); }

    if (tag && tag.mount) {
      tag.mount(true);
      // add this tag to the virtualDom variable
      if (!contains(__TAGS_CACHE, tag)) { __TAGS_CACHE.push(tag); }
    }

    return tag
  }



  var tags = /*#__PURE__*/Object.freeze({
    arrayishAdd: arrayishAdd,
    getTagName: getName,
    inheritParentProps: inheritParentProps,
    mountTo: mount$1,
    selectTags: query,
    arrayishRemove: arrayishRemove,
    getTag: get,
    initChildTag: initChild,
    moveChildTag: moveChild,
    makeReplaceVirtual: makeReplaceVirtual,
    getImmediateCustomParentTag: getImmediateCustomParent,
    makeVirtual: makeVirtual,
    moveVirtual: moveVirtual,
    unmountAll: unmountAll,
    createIfDirective: createIfDirective,
    createRefDirective: createRefDirective
  });

  /**
   * Riot public api
   */
  var settings$1 = settings;
  var util = {
    tmpl: tmpl,
    brackets: brackets,
    styleManager: styleManager,
    vdom: __TAGS_CACHE,
    styleNode: styleManager.styleNode,
    // export the riot internal utils as well
    dom: dom,
    check: check,
    misc: misc,
    tags: tags
  };

  // export the core props/methods
  var Tag$1 = Tag;
  var tag$1 = tag;
  var tag2$1 = tag2;
  var mount$2 = mount;
  var mixin$1 = mixin;
  var update$2 = update$1;
  var unregister$1 = unregister;
  var version$1 = version;
  var observable$1 = observable;

  var riot$1 = extend({}, core, {
    observable: observable,
    settings: settings$1,
    util: util,
  })

  exports.settings = settings$1;
  exports.util = util;
  exports.Tag = Tag$1;
  exports.tag = tag$1;
  exports.tag2 = tag2$1;
  exports.mount = mount$2;
  exports.mixin = mixin$1;
  exports.update = update$2;
  exports.unregister = unregister$1;
  exports.version = version$1;
  exports.observable = observable$1;
  exports.default = riot$1;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ })

},[489]);


// WEBPACK FOOTER //
// riot/build/riot.js